import THIRD_PARTY_API from "axios";
import {
  assign,
  capitalize,
  filter,
  find,
  forEach,
  forIn, get,
  has, intersection,
  isArray,
  isEmpty as isLodashEmpty, isEqual, isNil,
  isString,
  keys,
  map,
  reduce,
  set,
  some, union,
  uniq,
  unset,
  uniqBy,
  lowerFirst,
  values,
  upperFirst,
  findKey,
  sortBy,
  findIndex,
  sumBy,
  remove
} from "lodash";
import moment from "moment";
import React from "react";
import { toast } from "react-toastify";
import { t } from "../../infrastructure/localization/localizationservice";
import { logError } from "../../infrastructure/logging/Logger";
import { API } from "../../infrastructure/network/HttpClient";
import {
  CONDITIONAL_SHOWHIDE_KEYS,
  CONTENT_TOKEN,
  DEFAULT_PROMO_CODE_MASTER_KEY,
  EntityFieldNameByCriteriaValue,
  FORM_INPUT_DEFAULT_PARAMETERS,
  FORM_INPUT_UI,
  FORM_INPUT_VALUE_FORMAT,
  FORM_LAYOUT_PARAMETERS_KEYS,
  HARD_CODED_FIELD_KEYS,
  MasterDataCollectionByCriteriaValue,
  MOBILE_VALIDATE_LAST_TEN_DIGIT,
  REQUEST_TYPE,
  STEP_NAVIGATION_TYPE,
  STORAGE_KEY,
  STORAGE_TYPE,
  VALIDATION_MESSAGE_TOKEN,
  MASTER_KEYS,
  META_DATA_TYPE,
  META_DATA_INDEXED_VALUE_TYPE,
  FEES_TYPE,
  PAYMENT_SUCCESS_STATUS,
  EXCEPTIONAL_DATACOLLECTION_MAPPING,
  DEFAULT_CURRENCY,
  PROMOCODE_DISCOUNT_TYPE
} from "./Constants";
import { LeadObjectManager } from "./LeadObjectManager";
import { OfflineStorage } from "./OfflineStorage";
import NotVerifiedIcon from "../../shared/icons/exclamation_red.svg";
import VerifiedIcon from "../../shared/icons/verified_green.svg";
import EditIcon from "../../shared/icons/edit_grey.svg";
import Axios from "axios";
import eeAzureLogs from '../../shared/services/eeAzureLogs'
import { updateFormConfig } from "../../pages/form/Actions";

window.moment = moment;
export const leadObjectManager = new LeadObjectManager();
export const eeCustomAzureLogs = new eeAzureLogs()
//leadObjectManager.getValue("application.keyValueAttributes", { keyId: 5 });
var jwtDecode = require("jwt-decode");

export function isAccessTokenValid(accessToken) {
  if (accessToken) {
    let decodedToken = jwtDecode(accessToken);
    let currentTime = Date.now();
    let expTime = parseInt(decodedToken.exp + "000");
    let diff = currentTime - expTime;
    if (diff >= -120000) return false;
    else return true;
  }
}
//get offline storage client info saved in JSON format
export function getClientInfomation(key, isPersistant) {
  let oData = JSON.parse(
    OfflineStorage.getItem(STORAGE_KEY.CLIENT_INFO, isPersistant)
  );
  return oData && oData[key] !== undefined ? oData[key] : null;
}

/**@description get client configured to store in reducer */
export function getClientConfiguration() {
  return window.extraaedge &&
    window.extraaedge.client &&
    window.extraaedge.client.Info
    ? window.extraaedge.client.Info
    : null;
}
/**
 * @param {string} source - Source string which will have token text
 * @param {Object} tokens - array of objects where each object have find and replace value
 * @example tokens [{find:"$NAME$",replace:"John"}, {find:"$EMAIL$,replace:'john@mydomain.com'}]
 * @returns {string} output - String with replace all token with actual values
 */
export function findAndReplaceInString(source, tokens) {
  if (tokens && tokens.length === 0) return source;
  tokens.map((item) => {
    return (source = source.split(item.find).join(item.replace));
  });
  return source;
}
/**
 *
 * @param {string} param {pattern:"^([a-zA-Z ]+)$",val:"Hellow"}
 */
export function isRegExValidate(param) {
  return new RegExp(param.pattern).test(param.val);
}
export function isEmpty(str) {
  return (
    isNil(str) ||
    (Array.isArray(str) && str.length === 0) ||
    (isString(str) && str.trim() === "")
  );
}
export function getStoreSettingByKey(key, masterData) {
  return masterData && (masterData[key] || masterData[lowerFirst(key)])
}
export function getMasterDataByKey(key, masterData,dataCollectionFilterOptions=null) {
  let collection=masterData && (masterData[key] || masterData[lowerFirst(key)]);
  const EXCEPTIONAL_DATACOLLECTION_MAPPING_KEYS_VALUES = checkIfObject(EXCEPTIONAL_DATACOLLECTION_MAPPING) ? [...keys(EXCEPTIONAL_DATACOLLECTION_MAPPING), ...values(EXCEPTIONAL_DATACOLLECTION_MAPPING)] : [];
  if(
    !collection && checkIfArray(EXCEPTIONAL_DATACOLLECTION_MAPPING_KEYS_VALUES) && 
    (EXCEPTIONAL_DATACOLLECTION_MAPPING_KEYS_VALUES.indexOf(key)!==-1 || EXCEPTIONAL_DATACOLLECTION_MAPPING_KEYS_VALUES.indexOf(upperFirst(key))!==-1)
  ){
    const vals = values(EXCEPTIONAL_DATACOLLECTION_MAPPING);
    if(vals.indexOf(key)!==-1 || vals.indexOf(upperFirst(key))!==-1){
      const newkey = findKey(EXCEPTIONAL_DATACOLLECTION_MAPPING,(objectValue,objectKey)=>{
        return objectValue.toLowerCase()===key.toLowerCase();
      })
      if(!!newkey){
        key = newkey;
      }
    }
    collection=masterData[key] || masterData[lowerFirst(key)]; 
  }
  if (collection && !dataCollectionFilterOptions) {
    return filter(collection, function (o) {
      /*return (
        ((o.isActive !== undefined && o.Active === true) || true) &&
        !o.isSystemValue
      );*/
      return (
        (isNil(o.isActive) || o.isActive === true) &&
        (isNil(o.isSystemValue) || o.isSystemValue === false)
      );
    });
  } else if(collection && !!dataCollectionFilterOptions) {
    const excludeIds=!!get(dataCollectionFilterOptions,`excludeIds`) && Array.isArray(dataCollectionFilterOptions.excludeIds) && dataCollectionFilterOptions.excludeIds.length>0?dataCollectionFilterOptions.excludeIds:null;

    const includeIds=!!get(dataCollectionFilterOptions,`includeIds`) && Array.isArray(dataCollectionFilterOptions.includeIds) && dataCollectionFilterOptions.includeIds.length>0?dataCollectionFilterOptions.includeIds:null;
    /**
     * Date: 05th Jan 2022
     * Pradip Udavant
     * Case 1: If excludeIds will come [-1] as value then this function will return values only having in includeIds array
     * Case 2: If excludeIds will come with other ids then this will return values exclude mentioend ids from data collection
     */
    if(!!excludeIds && excludeIds.length===1 && excludeIds.includes(-1) && !!includeIds && includeIds.length>0){
      //case 1 logic
      return filter(collection, function (o) {
        return (
          (isNil(o.id) || includeIds.includes(o.id)) && 
          (isNil(o.isActive) || o.isActive === true) &&
          (isNil(o.isSystemValue) || o.isSystemValue === false)
        );
      });
    }else if(!!excludeIds && (!excludeIds.includes(-1) || excludeIds.length>1)){
      //case 2 logic
      return filter(collection, function (o) {
        return (
          (isNil(o.id) || !excludeIds.includes(o.id)) && 
          (isNil(o.isActive) || o.isActive === true) &&
          (isNil(o.isSystemValue) || o.isSystemValue === false)
        );
      });
    }
  } else {
    //logError("Master collection not found for: ", key);
    return null;
  }
}

export function getNameById(id, collection) {
  let name = null;
  if (
    !!id &&
    collection &&
    Array.isArray(collection) &&
    collection.length > 0
  ) {
    let item = find(collection, { id });
    name = item && !!item.name ? item.name : name;
  }
  return name;
}
/**
 * Validate input by regex pattern
 * @param {*} val
 * @param {*} type
 * @param {*} pattern
 */
export function validateByType(val, type, pattern) {
  switch (type) {
    case FORM_INPUT_UI.DATE: {
      // let _val = val;
      return true;
    }
    case FORM_INPUT_UI.EMAIL:
      return isRegExValidate({ pattern: pattern, val: val });
    case FORM_INPUT_UI.MOBILE:
      return isRegExValidate({ pattern: pattern, val: val });
    case FORM_INPUT_UI.NUMBER: {
      // let _val = val;
      if (!isEmpty(pattern) && !isEmpty(val)) {
        return isRegExValidate({ pattern: pattern, val: val });
      }
      return true;
    }
    case FORM_INPUT_UI.PASSWORD: {
      return isRegExValidate({ pattern: pattern, val: val });
    }
    case FORM_INPUT_UI.TEL: {
      // let _val = val;
      return true;
    }
    case FORM_INPUT_UI.TEXT: {
      // let _val = val;
      if (!isEmpty(pattern) && !isEmpty(val)) {
        return isRegExValidate({ pattern: pattern, val: val });
      }
      return true;
    }
    case FORM_INPUT_UI.TEXTAREA: {
      // let _val = val;
      return true;
    }
    case FORM_INPUT_UI.URL: {
      // let _val = val;
      return isRegExValidate({ pattern: pattern, val: val });
    }
    case FORM_INPUT_UI.WEEK: {
      // let _val = val;
      return true;
    }
    default: {
      return false;
    }
  }
}
/**
 *
 * @param {*} val
 * @param {*} type
 * @param {*} validationRules
 */
export function validateByRule(val, type, validationRules) {
  switch (type) {
    case FORM_INPUT_UI.DATE:
      return true;
    case FORM_INPUT_UI.EMAIL:
      return true;
    case FORM_INPUT_UI.MOBILE:
      return true;
    case FORM_INPUT_UI.NUMBER: {
      // let _val = val;
      if (!isNil(val) && !isEmpty(val) && !isNil(validationRules)) {
        if (
          !isNil(validationRules.min) &&
          !isEmpty(validationRules.min) &&
          !isNil(validationRules.max) &&
          !isEmpty(validationRules.max)
        ) {
          return (
            parseFloat(val) <= parseFloat(validationRules.max) &&
            parseFloat(val) >= parseFloat(validationRules.min)
          );
        } else if (
          !isNil(validationRules.min) &&
          !isEmpty(validationRules.min)
        ) {
          return parseFloat(val) >= parseFloat(validationRules.min);
        } else if (
          !isNil(validationRules.max) &&
          !isEmpty(validationRules.max)
        ) {
          return parseFloat(val) <= parseFloat(validationRules.max);
        }
      }
      return true;
    }
    case FORM_INPUT_UI.PASSWORD:
      return true;
    case FORM_INPUT_UI.TEL:
      return true;
    case FORM_INPUT_UI.TEXT:
      return true;
    case FORM_INPUT_UI.TEXTAREA:
      return true;
    case FORM_INPUT_UI.URL:
      return true;
    case FORM_INPUT_UI.WEEK:
      return true;
    default:
      return false;
  }
}

/**
 * Validate input by for unique value within same input type
 * @param {*} val
 * @param {*} type
 * @param {*} pattern
 */
export function validateForUniqueValue(
  val,
  type,
  pattern,
  isUniqueValueCheckEnabled,
  formData,
  uniqueFieldByInputType,
  userDetail,
  key
) {
  let validateResult = null;
  switch (type) {
    case FORM_INPUT_UI.DATE: {
      return validateResult;
    }
    case FORM_INPUT_UI.EMAIL:
      if (
        !isNil(val) &&
        !isLodashEmpty(val) &&
        !isNil(isUniqueValueCheckEnabled) &&
        isUniqueValueCheckEnabled &&
        !isNil(formData) &&
        !isNil(uniqueFieldByInputType) &&
        !isNil(get(uniqueFieldByInputType, type)) &&
        Array.isArray(uniqueFieldByInputType[type]) &&
        uniqueFieldByInputType[type].length > 0
      ) {
        //hard code to check for primary email mobile entered at registration page
        const primaryEmail = get(userDetail, `user.email`);
        let duplicateValueFieldTitle =
          !isNil(primaryEmail) && !isLodashEmpty(primaryEmail)
            ? val.toLowerCase() === primaryEmail.toLowerCase()
              ? "form.fields.primaryEmailAddress.title"
              : ""
            : "";
        !duplicateValueFieldTitle &&
          uniqueFieldByInputType[type].some((item) => {
            const { fieldKey, title } = item;
            const isSameValueFound =
              !isNil(key) &&
              !isLodashEmpty(key) &&
              key.toLowerCase() !== fieldKey.toLowerCase() &&
              !isNil(get(formData, fieldKey)) &&
              !isLodashEmpty(get(formData, fieldKey)) &&
              val.toLowerCase() === get(formData, fieldKey).toLowerCase();
            if (isSameValueFound) duplicateValueFieldTitle = title;
            return isSameValueFound;
          });
        if (!!duplicateValueFieldTitle) {
          validateResult = {
            duplicateValueFieldName: getLang(duplicateValueFieldTitle),
          };
        }
      }
      return validateResult;
    case FORM_INPUT_UI.MOBILE:
    case FORM_INPUT_UI.MOBILE2:
      let inputMobile =
        !isNil(val) && !isLodashEmpty(val)
          ? MOBILE_VALIDATE_LAST_TEN_DIGIT
            ? val.substr(-10)
            : val
          : val;
      if (
        !isNil(inputMobile) &&
        !isLodashEmpty(inputMobile) &&
        !isNil(isUniqueValueCheckEnabled) &&
        isUniqueValueCheckEnabled &&
        !isNil(formData) &&
        !isNil(uniqueFieldByInputType) &&
        !isNil(get(uniqueFieldByInputType, type)) &&
        Array.isArray(uniqueFieldByInputType[type]) &&
        uniqueFieldByInputType[type].length > 0
      ) {
        //hard code to check for primary email mobile entered at registration page
        const primaryMobileNumber = !!get(userDetail, `user.mobileNumber`)
          ? MOBILE_VALIDATE_LAST_TEN_DIGIT
            ? get(userDetail, `user.mobileNumber`).substr(-10)
            : get(userDetail, `user.mobileNumber`)
          : get(userDetail, `user.mobileNumber`);
        let duplicateValueFieldTitle =
          !isNil(primaryMobileNumber) && !isLodashEmpty(primaryMobileNumber)
            ? inputMobile.toLowerCase() === primaryMobileNumber.toLowerCase()
              ? "form.fields.primaryMobileNumber.title"
              : ""
            : "";
        !duplicateValueFieldTitle &&
          uniqueFieldByInputType[type].some((item) => {
            const { fieldKey, title } = item;

            let fieldValue =
              !isNil(get(formData, fieldKey)) &&
              !isLodashEmpty(get(formData, fieldKey))
                ? MOBILE_VALIDATE_LAST_TEN_DIGIT
                  ? get(formData, fieldKey).substr(-10)
                  : get(formData, fieldKey)
                : get(formData, fieldKey);
            const isSameValueFound =
              !isNil(key) &&
              !isLodashEmpty(key) &&
              key.toLowerCase() !== fieldKey.toLowerCase() &&
              !isNil(fieldValue) &&
              !isLodashEmpty(fieldValue) &&
              inputMobile.toLowerCase() === fieldValue.toLowerCase();
            if (isSameValueFound) duplicateValueFieldTitle = title;
            return isSameValueFound;
          });
        if (!!duplicateValueFieldTitle) {
          validateResult = {
            duplicateValueFieldName: getLang(duplicateValueFieldTitle),
          };
        }
      }
      return validateResult;
    case FORM_INPUT_UI.NUMBER: {
      return validateResult;
    }
    case FORM_INPUT_UI.PASSWORD: {
      return validateResult;
    }
    case FORM_INPUT_UI.TEL: {
      return validateResult;
    }
    case FORM_INPUT_UI.TEXT: {
      return validateResult;
    }
    case FORM_INPUT_UI.TEXTAREA: {
      return validateResult;
    }
    case FORM_INPUT_UI.URL: {
      return validateResult;
    }
    case FORM_INPUT_UI.WEEK: {
      return validateResult;
    }
    default: {
      return validateResult;
    }
  }
}
/**
 * @description Check file size in kb is valid or not
 * @param {*} fdata
 * @param {*} maxSize
 */
export function fileSizeValidate(fdata, maxSize) {
  var fsize = fdata.size / 1024;
  if (fsize > maxSize) {
    //alert("Maximum file size exceed, This file size is: " + fsize + "KB");
    return false;
  } else {
    return true;
  }
}

/**
 * @description Check file name characters length is valid or not
 * @param {*} fileNameWithoutExtension
 * @param {*} fileNameMaxLength
 */
export function fileNameLengthValidate(
  fileNameWithoutExtension,
  fileNameMaxLength
) {
  if (!isEmpty(fileNameWithoutExtension) && !isEmpty(fileNameMaxLength)) {
    return fileNameWithoutExtension.length <= fileNameMaxLength;
  }
  return true;
}
/**
 * Check input config and add div for move input field at new row
 */
export function ConditionalLayoutToMoveInputAtNewRow(params) {
  let moveToNewRow =
    params &&
    params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES] &&
    params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
      FORM_LAYOUT_PARAMETERS_KEYS.MOVE_TO_NEW_ROW
    ]
      ? params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
          FORM_LAYOUT_PARAMETERS_KEYS.MOVE_TO_NEW_ROW
        ] !== undefined
        ? params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
            FORM_LAYOUT_PARAMETERS_KEYS.MOVE_TO_NEW_ROW
          ]
        : FORM_INPUT_DEFAULT_PARAMETERS[
            FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES
          ][FORM_LAYOUT_PARAMETERS_KEYS.MOVE_TO_NEW_ROW]
      : false;
  return (
    <div
      key={params.name + "2"}
      className={moveToNewRow ? "w-100" : "d-none"}
    />
  );
}
/**
 * Check input col width from form config
 */
export function getColWidth(params, formConfig) {
  //get block width form contants
  let blockWidth =
    FORM_INPUT_DEFAULT_PARAMETERS[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
      FORM_LAYOUT_PARAMETERS_KEYS.WIDTH
    ];
  //check and get if exist block width in provided form config object
  blockWidth =
    formConfig &&
    formConfig.defaultProps &&
    formConfig.defaultProps.fields &&
    formConfig.defaultProps.fields[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES] &&
    !!formConfig.defaultProps.fields[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
      FORM_LAYOUT_PARAMETERS_KEYS.WIDTH
    ]
      ? formConfig.defaultProps.fields[
          FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES
        ][FORM_LAYOUT_PARAMETERS_KEYS.WIDTH]
      : blockWidth;
  //check and get if exist block width in provided params object
  blockWidth =
    params &&
    params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES] &&
    !!params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
      FORM_LAYOUT_PARAMETERS_KEYS.WIDTH
    ]
      ? params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
          FORM_LAYOUT_PARAMETERS_KEYS.WIDTH
        ]
      : blockWidth;
  let offset =
    params &&
    params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES] &&
    !!params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
      FORM_LAYOUT_PARAMETERS_KEYS.OFFSET
    ]
      ? params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
          FORM_LAYOUT_PARAMETERS_KEYS.OFFSET
        ]
      : false;
  return !offset
    ? FORM_LAYOUT_PARAMETERS_KEYS[blockWidth]
    : {
        size: FORM_LAYOUT_PARAMETERS_KEYS[blockWidth],
        [FORM_LAYOUT_PARAMETERS_KEYS.OFFSET]: offset,
      };
}
/**
 * check each steps to add key to specific fields 
 */
export function updateKeyToFields(actionItem, configs, addKeys, placeKey){
  const { steps } = configs || {};
  checkIfArray(steps) && steps.map(step => {
    const { panels } = step?.config || {};
    if(checkIfObject(panels)){
      for (const [keyPanel, valuePanel] of Object.entries(panels)) {
        const { fields, visible } = valuePanel || {};
        const fieldsKey = Object.keys(fields);
        visible && checkIfArray(addKeys) && addKeys.map(addKey => {
          if(fieldsKey.includes(addKey) && fields[addKey].visible){
            if(actionItem === "add"){
              if(placeKey === "conditionShow"){
                fields[addKey][placeKey] = true;
              }else{
                !panels[keyPanel][placeKey].includes(addKey) && panels[keyPanel][placeKey].push(addKey);
              }
            }else{
              if(placeKey === "conditionShow"){
                fields[addKey][placeKey] = false;
              }else{
                if(panels[keyPanel][placeKey] && Array.isArray(panels[keyPanel][placeKey]) && panels[keyPanel][placeKey].includes(addKey)){
                  panels[keyPanel][placeKey] = panels[keyPanel][placeKey].filter((item) => {
                    return item !== addKey;
                  });
                }
              }
            }
          }
        })
      }
    }
  })
}
/**
 * update visibility component as mentined in "ref" in form config
 */
export function updateDependenciesRefComponents(
  params,
  value,
  currentStepData,
  isRecursiveFormConfigChanged,
  conditionallyRemovedFields,
  updatedConfig={}
) {
  conditionallyRemovedFields =
    !!conditionallyRemovedFields &&
    Object.keys(conditionallyRemovedFields).length > 0
      ? conditionallyRemovedFields
      : {};

  let isFormConfigChanged = false;
  let isConditionalTrue = false;
  //console.log(`params`,params);
  let globalRef = [{ ref: params.ref }];
  if (!isNil(params.trueCondition) && params.trueCondition === value) {
    isConditionalTrue = true;
    globalRef[0].isConditionalTrue = true;
  }
  if (
    isNil(params.trueCondition) &&
    (params.type === FORM_INPUT_UI.TEXT ||
      params.type === FORM_INPUT_UI.FILE ||
      params.type === FORM_INPUT_UI.HIDDEN ||
      params.type === FORM_INPUT_UI.URL
    ) &&
    !!value
  ) {
      isConditionalTrue = true;
      globalRef[0].isConditionalTrue = true;
  } else if (
    isNil(params.trueCondition) &&
    params.type === FORM_INPUT_UI.SELECT &&
    !isNil(value)
  ) {
    //condition for dropdown - to show specific field(s) on any selected value
    if (
      !isNil(get(params, `ref.conditional`)) &&
      Array.isArray(params.ref.conditional) &&
      params.ref.conditional.length > 0
    ) {
      forEach(params.ref.conditional, function (item) {
        if (
          !!item.onSelectIds &&
          Array.isArray(item.onSelectIds) &&
          item.onSelectIds.length > 0 &&
          intersection(item.onSelectIds, Array.isArray(value) ? value : [value])
            .length > 0 &&
          Object.keys(item).length > 1
        ) {
          globalRef.push({ ref: item, isConditionalTrue: true });
        } else {
          globalRef.push({ ref: item, isConditionalTrue: false });
        }
      });
    } else if (
      !isNil(get(params, `ref.onSelectIds`)) &&
      Array.isArray(params.ref.onSelectIds) &&
      params.ref.onSelectIds.length > 0 &&
      ((Array.isArray(value) && value.length > 0) || !isNil(value)) &&
      intersection(
        params.ref.onSelectIds,
        Array.isArray(value) ? value : [value]
      ).length > 0
    ) {
      //condition for dropdown - to show Other text field found true
      isConditionalTrue = true;
      globalRef[0].isConditionalTrue = true;
    } else {
      isConditionalTrue = false;
      globalRef[0].isConditionalTrue = false;
    }
  }
  checkIfArray(updatedConfig.steps) && updatedConfig.steps.forEach(stepConfig => {
  let stepData = stepConfig.config || {};
  stepData &&
    stepData.panels &&
    Object.keys(stepData.panels).length > 0 &&
    Object.keys(stepData.panels).map((panelKey) => {
      let panel = stepData.panels[panelKey];
      let hidePanels = filter(globalRef, (item) => {
        return (
          !isNil(get(item, `ref.hidePanels`)) &&
          Array.isArray(item.ref.hidePanels) &&
          item.ref.hidePanels.length > 0 &&
          item.ref.hidePanels.includes(panelKey)
        );
      });
      let showPanels = filter(globalRef, (item) => {
        return (
          !isNil(get(item, `ref.showPanels`)) &&
          Array.isArray(item.ref.showPanels) &&
          item.ref.showPanels.length > 0 &&
          item.ref.showPanels.includes(panelKey)
        );
      });
      if (stepData && hidePanels.length > 0) {
        panel["conditionShow"] = !some(hidePanels, { isConditionalTrue: true });
        //delete stepData.panels[panelKey];
        //stepData.panels[panelKey] = Object.assign({}, panel);
        isFormConfigChanged = true;
      }
      if (stepData && showPanels.length > 0) {
        panel["conditionShow"] = some(showPanels, { isConditionalTrue: true });
        //delete stepData.panels[panelKey];
       // stepData.panels[panelKey] = Object.assign({}, panel);
        isFormConfigChanged = true;
      }
      panel.fields &&
        Object.keys(panel.fields).length > 0 &&
        Object.keys(panel.fields).map((fieldkey) => {
          let field = panel.fields[fieldkey];
          let hideFields = filter(globalRef, (item) => {
            return (
              !isNil(get(item, `ref.hideFields`)) &&
              Array.isArray(item.ref.hideFields) &&
              item.ref.hideFields.length > 0 &&
              item.ref.hideFields.includes(fieldkey)
            );
          });
          let showFields = filter(globalRef, (item) => {
            return (
              !isNil(get(item, `ref.showFields`)) &&
              Array.isArray(item.ref.showFields) &&
              item.ref.showFields.length > 0 &&
              item.ref.showFields.includes(fieldkey)
            );
          });
          
          if (stepData && hideFields.length > 0) {
            field["conditionShow"] = !some(hideFields, {
              isConditionalTrue: true,
            });
            //delete panel.fields[fieldkey];
           // panel.fields[fieldkey] = Object.assign({}, field);
            !some(hideFields, { isConditionalTrue: true }) &&
              set(conditionallyRemovedFields, fieldkey, null);
            isRecursiveFormConfigChanged =
              (!some(hideFields, { isConditionalTrue: true }) &&
                !isNil(get(field, "ref")) &&
                intersection(CONDITIONAL_SHOWHIDE_KEYS, Object.keys(field.ref))
                  .length > 0 &&
                updateDependenciesRefComponents(
                  field,
                  null,
                  currentStepData,
                  isRecursiveFormConfigChanged,
                  conditionallyRemovedFields,
                  updatedConfig
                )) ||
              isRecursiveFormConfigChanged;
            isFormConfigChanged = true;
          }
          if (stepData && showFields.length > 0) {
            field["conditionShow"] = some(showFields, {
              isConditionalTrue: true,
            });
            //delete panel.fields[fieldkey];
            //panel.fields[fieldkey] = Object.assign({}, field);
            !some(showFields, { isConditionalTrue: true }) &&
              set(conditionallyRemovedFields, fieldkey, null);
            isRecursiveFormConfigChanged =
              (!some(showFields, { isConditionalTrue: true }) &&
                !isNil(get(field, "ref")) &&
                intersection(CONDITIONAL_SHOWHIDE_KEYS, Object.keys(field.ref))
                  .length > 0 &&
                updateDependenciesRefComponents(
                  field,
                  null,
                  currentStepData,
                  isRecursiveFormConfigChanged,
                  conditionallyRemovedFields,
                  updatedConfig
                )) ||
              isRecursiveFormConfigChanged;
            isFormConfigChanged = true;
          }
          if (
            stepData &&
            checkIfArray(params.dependencies)
          ) {
            if(params.dependencies.includes(fieldkey)){
              
              if (!!value) {
                if (panel["required"] === undefined)
                  panel["required"] = [fieldkey];
                else if (!panel["required"].includes(fieldkey)) {
                  panel["required"].push(fieldkey);
                  //panel = Object.assign({}, panel);
                }
              } else if (
                panel["required"] !== undefined &&
                panel["required"].includes(fieldkey)
              ) {
                panel["required"] = panel["required"].filter((item) => {
                  return item !== fieldkey;
                });
                //panel = Object.assign({}, panel);
              }
            }else{
              if(value && Array.isArray(value) ? value.length : value){
                //logic of dependencies for other steps written below
                updateKeyToFields("add", updatedConfig, params.dependencies, "required")
              }else{
                updateKeyToFields("remove", updatedConfig, params.dependencies, "required")
              }
            }
            isFormConfigChanged = true;
          }
          return true;
        });
      return true;
    });
  });
  return { isFormConfigChanged, conditionallyRemovedFields };
}
export function updatefieldsRefConditions(steps, currentStep, formData, formConfig) {
  let updatedConfig = {}, refDependencyFields = {}, refShowFields = [], refHideFields = [], currentStepFields = [];
  if(checkIfArray(steps) && currentStep && checkIfObject(formData)){
    const currentStepData = steps[currentStep - 1];
    const panels = currentStepData?.config?.panels;
    if(checkIfObject(panels)){
      const panelValue = Object.values(panels);
      if(checkIfArray(panelValue)){
        panelValue.forEach(panel => {
          const allField = panel?.fields || {};
          for (const [fieldKey, fieldValue] of Object.entries(allField)) {
            if(fieldValue?.visible){
              currentStepFields.push(fieldKey);
            }
          }
        })
      }
    }
    steps.forEach(step => {
      const panels = step?.config?.panels;
      if(checkIfObject(panels)){
        const panelValue = Object.values(panels);
        if(checkIfArray(panelValue)){
          panelValue.forEach(panel => {
            const allField = panel?.fields || {};
            for (const [fieldKey, fieldValue] of Object.entries(allField)) {
              if(fieldValue?.visible){
                const val = formData[fieldKey] && (typeof formData[fieldKey] === 'string' || formData[fieldKey] instanceof String) ? 
                formData[fieldKey] : Number(formData[fieldKey]);
                //fetch conditional keys
                if(checkIfArray(fieldValue?.ref?.conditional)){
                  fieldValue.ref.conditional.forEach(ele => {
                    if(checkIfArray(ele?.showFields) && ele.onSelectIds.includes(val)){
                      ele.showFields.forEach(field => {
                        if(currentStepFields.includes(field)){
                          refShowFields = [...(refShowFields || []), field]
                        }
                      })
                    }
                  })
                }
                //fetch dependency keys
                if(checkIfArray(fieldValue?.dependencies)){
                  fieldValue.dependencies.forEach(dependency => {
                    const trueValue = fieldValue.trueCondition ? fieldValue.trueCondition === val : val;
                    if(currentStepFields.includes(dependency) && trueValue){
                      refDependencyFields[dependency] = [...(refDependencyFields[dependency] || []), fieldKey]
                    }
                  })
                }
                //fetch showFields keys
                if(checkIfArray(fieldValue?.ref?.showFields)){
                  if(fieldValue?.ref?.onSelectIds ? fieldValue.ref.onSelectIds.includes(val) : fieldValue.trueCondition ? fieldValue.trueCondition === val : val){
                    fieldValue.ref.showFields.forEach(field => {
                      if(currentStepFields.includes(field)){
                        refShowFields = [...(refShowFields || []), field]
                      }
                    })
                  }else{
                    fieldValue.ref.showFields.forEach(field => {
                      if(currentStepFields.includes(field)){
                        refHideFields= [...(refHideFields || []), field]
                      }
                    })
                  }
                }
              }
            }
          })
        }
      }
    })
    updatedConfig = formConfig;
    //dependencies logic
    let updatedFlag = false;
    if(checkIfObject(refDependencyFields)){
      for (const [dependentKey, dependenyValue] of Object.entries(refDependencyFields)) {
        if(checkIfArray(dependenyValue)){
          dependenyValue.forEach(dependentVal => {
            const value = formData[dependentVal];
            updatedFlag = true;
            if(value && Array.isArray(value) ? value.length : value){
              updateKeyToFields("add", updatedConfig, [dependentKey], "required");
            }else{
              updateKeyToFields("remove", updatedConfig, [dependentKey], "required")
            }
          })
        }
      }
    }
    //hideFields logic
    if(checkIfArray(refHideFields)){
      updatedFlag = true;
      updateKeyToFields("remove", updatedConfig, refHideFields, "conditionShow");
    }
    if(checkIfArray(refShowFields)){
      updatedFlag = true;
      updateKeyToFields("add", updatedConfig, refShowFields, "conditionShow");
    }
    //update final config logic
    if(checkIfObject(updatedConfig) && updatedFlag){
      updateFormConfig(updatedConfig)
    }
  }
  
}
/**
 * Check checkbox or radio list need to show inline or list format from form config
 */
export function getOptionListLayout(params, formConfig) {
  //get block width form contants
  let isIinelist =
    FORM_INPUT_DEFAULT_PARAMETERS[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
      FORM_LAYOUT_PARAMETERS_KEYS.INLINE_LIST
    ];
  //check and get if exist block width in provided form config object
  isIinelist =
    formConfig &&
    formConfig.defaultProps &&
    formConfig.defaultProps.fields &&
    formConfig.defaultProps.fields[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES] &&
    !!formConfig.defaultProps.fields[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
      FORM_LAYOUT_PARAMETERS_KEYS.INLINE_LIST
    ]
      ? formConfig.defaultProps.fields[
          FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES
        ][FORM_LAYOUT_PARAMETERS_KEYS.INLINE_LIST]
      : isIinelist;
  //check and get if exist block width in provided params object
  isIinelist =
    params &&
    params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES] &&
    !!params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
      FORM_LAYOUT_PARAMETERS_KEYS.INLINE_LIST
    ]
      ? params[FORM_LAYOUT_PARAMETERS_KEYS.LAYOUT_RULES][
          FORM_LAYOUT_PARAMETERS_KEYS.INLINE_LIST
        ]
      : isIinelist;

  return isIinelist;
}
/**
 * @description - Check language text is present for provided key and return TRUE or FALSE
 */
export function isLangExist(lnKey) {
  return !!lnKey && t(lnKey) !== lnKey;
}
/**
 * @description - get language text
 */
export function getLang(lnKey,defaultValue="") {
  return !!lnKey ? t(lnKey,!!defaultValue?defaultValue:lnKey) : "";
}
/**@description get master data collection value by id, we have maintained all master data will come with id and value format */
export function getValueById(id, collection) {
  let arr =
    collection && isArray(collection) && collection.length > 0
      ? collection
      : null;
  if (arr) {
    for (let i = 0; i < arr.length; i++) {
      if (!!arr[i].id && arr[i].id === id) {
        return !!arr[i].label ? arr[i].label : "";
      }
    }
  }
  return null;
}
/**
 * @description - Replace token with dynamic value {sourceStr: getLang(VALIDATION_ERROR.REQUIRED.errorMessage), name: getLang(fields[key].title), value: userInputvalue}
 */
export function replaceToken(params) {
  //property of params are expected sourceStr, name, value;
  if (
    params &&
    params.sourceStr &&
    VALIDATION_MESSAGE_TOKEN &&
    !isNil(params.name) &&
    params.sourceStr.indexOf(VALIDATION_MESSAGE_TOKEN.FIELD_NAME) !== -1
  ) {
    params.sourceStr = findAndReplaceInString(params.sourceStr, [
      {
        find: VALIDATION_MESSAGE_TOKEN.FIELD_NAME,
        replace: getLang(params.name),
      },
    ]);
  }
  if (
    params &&
    params.sourceStr &&
    VALIDATION_MESSAGE_TOKEN &&
    !isNil(params.value) &&
    params.sourceStr.indexOf(VALIDATION_MESSAGE_TOKEN.FIELD_VALUE) !== -1
  ) {
    params.sourceStr = findAndReplaceInString(params.sourceStr, [
      { find: VALIDATION_MESSAGE_TOKEN.FIELD_VALUE, replace: params.value },
    ]);
  }
  return params.sourceStr && params.sourceStr;
}
export function updateFormDataFromUserInfo(formConfig) {
  let userFormData = {};
  forEach(get(formConfig, "steps"), function (step, stepKey) {
    forEach(get(step, "config.panels"), function (panel, panelKey) {
      forEach(get(panel, "fields"), function (field, fieldKey) {
        let storedValue = "";
        if (field.db_key) {
          storedValue = leadObjectManager.getInputValue(
            fieldKey,
            field.db_key,
            field.db_key_id,
            field
          );
          if (!isEmpty(storedValue)) {
            storedValue =
              field.type === FORM_INPUT_UI.DATE
                ? ConvertToLocalUsingMoment(storedValue)
                : storedValue;
            assign(userFormData, { [fieldKey]: storedValue });
          }
        }
      });
    });
  });
  return keys(userFormData).length > 0 ? userFormData : null;
}

export function updateUserInfoFromFormData(
  formConfig,
  formData,
  initialFormData,
  isOnlyCheck
) {
  let updatedKeyMetaDataKey = [];
  let updatedIndexMetaDataKey = [];
  let isAnyValueUpdate = false;
  forEach(get(formConfig, "steps"), function (step, stepKey) {
    forEach(get(step, "config.panels"), function (panel, panelKey) {
      forEach(get(panel, "fields"), function (field, fieldKey) {
        let initialValue =
          initialFormData && Object.keys(initialFormData).includes(fieldKey)
            ? initialFormData[fieldKey]
            : null;
        let formValue =
          formData && Object.keys(formData).includes(fieldKey)
            ? formData[fieldKey]
            : null;
        if (
          field.db_key &&
          !(initialValue === null && formValue === null) &&
          JSON.stringify(initialValue) !== JSON.stringify(formValue)
        ) {
          isAnyValueUpdate = true;
          if (!!isOnlyCheck) return false;
          leadObjectManager.setInputValue(
            fieldKey,
            field,
            formData[fieldKey],
            updatedKeyMetaDataKey,
            updatedIndexMetaDataKey
          );
        }
      });
    });
  });
  return isAnyValueUpdate;
  //return keys(userFormData).length > 0 ? userFormData : null;
}
export function getUpdatedLeadStatusAndReason(
  lead_status_key,
  updateLeadStatus,
  masterData
) {
  if (
    !isEmpty(lead_status_key) &&
    !isEmpty(updateLeadStatus) &&
    !isEmpty(masterData)
  ) {
    let leadStatusTitle = map(
      filter(get(updateLeadStatus, "applicationFormStatusMapping"), {
        key: lead_status_key,
      }),
      "LeadStatusTitle"
    );
    let leadStatuses = !isNil(masterData) && getMasterDataByKey("LeadStatuses", masterData);
    let leadReasons = !isNil(masterData) && getMasterDataByKey("LeadReasons", masterData);
    let LeadStatusIds = map(
      filter(leadStatuses, function (o) {
        return (
          o.name ===
          (isArray(leadStatusTitle) ? leadStatusTitle[0] : leadStatusTitle)
        );
      }),
      "id"
    );
    let LeadReasonIds = map(
      filter(leadReasons, function (o) {
        return !!o.statusId && LeadStatusIds.includes(o.statusId);
      }),
      "id"
    );
    if (isEmpty(LeadReasonIds)) {
      LeadReasonIds = map(
        filter(leadReasons, function (o) {
          return o.Name === "Not Known";
        }),
        "id"
      );
    }
    return {
      statusId: isArray(LeadStatusIds) ? LeadStatusIds[0] : LeadStatusIds,
      reasonId: LeadReasonIds,
    };
  }
}
export function checkStepStatus(
  leadStatusId,
  lead_status_key,
  updateLeadStatus,
  masterData
) {
  if (
    updateLeadStatus &&
    !!updateLeadStatus.stepNavigation &&
    updateLeadStatus.stepNavigation === STEP_NAVIGATION_TYPE.NON_LINEAR
  ) {
    return true;
  } else if (
    updateLeadStatus &&
    !!updateLeadStatus.stepNavigation &&
    updateLeadStatus.stepNavigation === STEP_NAVIGATION_TYPE.LINEAR
  ) {
  }
}

export function getCurrentStatusMappingData(
  leadStatusId,
  updateLeadStatus,
  masterData
) {
  const leadStatuses = !isNil(masterData) && getMasterDataByKey(`LeadStatuses`,masterData);
  /*let currentLeadStatusTitle = map(
    filter(leadStatuses, {
      id: leadStatusId,
    }),
    "name"
  );*/
  const leadStatusObj = find(leadStatuses,{id: leadStatusId});
  const leadStatusName = !isNil(leadStatusObj) && get(leadStatusObj,`name`) ? leadStatusObj.name : null;
  let leadStatusMapping = leadStatusName && updateLeadStatus && checkIfArray(updateLeadStatus.applicationFormStatusMapping) ? filter(updateLeadStatus.applicationFormStatusMapping,
    function (o) {
      return leadStatusName.toLowerCase() === (o.LeadStatusTitle).toLowerCase();
    }
  ) : null;
  return checkIfArray(leadStatusMapping) ? leadStatusMapping : null;
}

export function getLeadStatusMappingObject(lead_status_key, updateLeadStatus) {
  if (!isEmpty(lead_status_key) && !isEmpty(updateLeadStatus)) {
    let leadStatusMapping = map(
      filter(get(updateLeadStatus, "applicationFormStatusMapping"), {
        key: lead_status_key,
      })
    );

    if (!!leadStatusMapping) {
      return leadStatusMapping[0];
    }
    return null;
  }
}
/**@description - Generate uploaded media url  */
export function getMediaLiveURL(fileName) {
  let clientConfig = OfflineStorage.getItem(
    STORAGE_KEY.CLIENT_INFO_REDUCER,
    STORAGE_TYPE.LOCAL
  );
  clientConfig = !!clientConfig && JSON.parse(clientConfig);
  /*let mediaStorage = clientConfig.mediaStorage
    ? clientConfig.mediaStorage
    : null;*/ 
    //Hard coded `mediaStorage` path as we missed to update path in config
  let mediaStorage={
      "blobURL": "https://eeresources-cdn.azureedge.net/",
      "blobFolder": "EmailAttachments"
  };
  let clientAlias =
    clientConfig[STORAGE_KEY.CLIENT_INFO] &&
    !!clientConfig[STORAGE_KEY.CLIENT_INFO][STORAGE_KEY.ALIAS]
      ? clientConfig[STORAGE_KEY.CLIENT_INFO][STORAGE_KEY.ALIAS]
      : null;
  if (
    mediaStorage &&
    !!mediaStorage.blobURL &&
    !!mediaStorage.blobFolder &&
    clientAlias
  ) {
    return (
      mediaStorage.blobURL +
      clientAlias +
      "/" +
      mediaStorage.blobFolder +
      "/" +
      fileName
    );
  } else {
    logError(
      "Required media storage blob details at client config json is not provided."
    );
  }
  return null;
}

export function getAvatarLiveURL(fileName) {
  let clientConfig = OfflineStorage.getItem(
    STORAGE_KEY.CLIENT_INFO_REDUCER,
    STORAGE_TYPE.LOCAL
  );
  clientConfig = !!clientConfig && JSON.parse(clientConfig);
  /*let mediaStorage = clientConfig.mediaStorage
    ? clientConfig.mediaStorage
    : null;*/ 
    //Hard coded `mediaStorage` path as we missed to update path in config
  let mediaStorage={
    "blobURL": "https://eeresources-cdn.azureedge.net/",
    "blobFolder": "EmailAttachments"
  };
  let clientAlias =
    clientConfig[STORAGE_KEY.CLIENT_INFO] &&
    !!clientConfig[STORAGE_KEY.CLIENT_INFO][STORAGE_KEY.ALIAS]
      ? clientConfig[STORAGE_KEY.CLIENT_INFO][STORAGE_KEY.ALIAS]
      : null;
  if (mediaStorage && !!mediaStorage.blobURL && clientAlias) {
    return (
      mediaStorage.blobURL +
      clientAlias +
      "/" +
      mediaStorage.blobFolder +
      "/" +
      fileName
    );
  } else {
    logError(
      "Required media storage blob details at client config json is not provided."
    );
  }
  return null;
}

export function isVariableEmpty(param) {
  return param !== undefined
    ? !((Array.isArray(param) && param.length > 0) || !!param)
    : true;
}
export function ConvertToLocalUsingMoment(dateTime,dateTimeFormat="YYYY-MM-DD", skipUTCConversion=false) {
  //let dateTimeFormat = "YYYY-MM-DD";
  if(skipUTCConversion){
    return moment(dateTime).format(dateTimeFormat);
  }
  let local = moment.utc(dateTime).local().format(dateTimeFormat);
  return local;
}
export function ConvertToUTCUsingMoment(dateTime) {
  let dateTimeFormat = "YYYY-MM-DD HH:mm";
  return moment(dateTime).utc().format(dateTimeFormat);
}
export function generateFormAndSubmit(params) {
  var form = document.createElement("form");
  form.setAttribute("method", params && !!params.type ? params.type : "post");
  form.setAttribute("action", params.url);
  //form.setAttribute("action", "http://localhost:33053/Payment/initialize");
  form.setAttribute("id", params.id);
  params &&
    params.formData &&
    Object.keys(params.formData).length > 0 &&
    Object.keys(params.formData).map((key) => {
      let i = document.createElement("input"); //input element, text
      i.setAttribute("type", "hidden");
      i.setAttribute("name", key);
      i.setAttribute("value", params.formData[key]);
      form.appendChild(i);
      return true;
    });
  document.getElementsByTagName("body")[0].appendChild(form);
  form.submit();
}
export function getTotalAmount(entity_keys, userDetail, masterData) {
  let pricingList = getMasterDataByKey("PricingList", masterData);
  if (!entity_keys && !userDetail && !masterData && !pricingList) {
    return false;
  }
  let prices =
    masterData &&
    map(
      filter(pricingList, (item) => {
        return entity_keys.includes(item.entityId);
      }),
      "amount"
    );
  let total = 0;
  prices &&
    prices.map((item) => {
      total += parseInt(item);
      return true;
    });
  return total;
}
export function getSelectedCourseIds(formData, masterData) {
  let pricingCriterion =
    masterData && !!masterData.pricingCriterion
      ? masterData.pricingCriterion
      : "";
  if (!pricingCriterion) return false;

  const pricingList = !isNil(masterData) && getMasterDataByKey("PricingList", masterData);
  if (
    formData &&
    !!formData[pricingCriterion + "Id"] &&
    checkIfArray(pricingList)
  ) {
    let entity_keys =
      formData[pricingCriterion + "Id"] &&
      Array.isArray(formData[pricingCriterion + "Id"])
        ? formData[pricingCriterion + "Id"]
        : [formData[pricingCriterion + "Id"]];
    return entity_keys;
  }
  return false;
}
export function getStatusIdAndReasonIds(
  LeadStatusTitle,
  masterData,
  clientInfo
) {
  if(!!LeadStatusTitle){
    let leadStatuses = !isNil(masterData) && getMasterDataByKey("LeadStatuses", masterData);
    let leadReasons = !isNil(masterData) && getMasterDataByKey("LeadReasons", masterData);
    if (checkIfArray(leadStatuses) && checkIfArray(leadReasons)) {
      let statusData = !!LeadStatusTitle
        ? find(leadStatuses, {
            name: LeadStatusTitle,
          })
        : null;
      if (!statusData || !statusData.id) {
        return false;
      }
      let mappedReason = find(leadReasons, { statusId: statusData.id });
      return (
        statusData &&
        mappedReason &&
        !!statusData.id &&
        !!mappedReason.id && {
          statusId: statusData.id,
          reasonId: mappedReason.id,
        }
      );
    }
  }
  return false;
}
export function getMappedSuccessAndFailStatus(
  paymentModeId,
  clientInfo,
  lead_status_key
) {
  if (
    !!paymentModeId &&
    clientInfo &&
    clientInfo.paymentDetails &&
    clientInfo.paymentDetails.ModesOfPayment &&
    Array.isArray(clientInfo.paymentDetails.ModesOfPayment) &&
    clientInfo.paymentDetails.ModesOfPayment.length > 0
  ) {
    let details = find(clientInfo.paymentDetails.ModesOfPayment, {
      id: parseInt(paymentModeId),
    });
    if (
      !isNil(details) &&
      !isNil(lead_status_key) &&
      !isEmpty(lead_status_key) &&
      !isNil(get(details, lead_status_key)) &&
      !isEmpty(get(details, lead_status_key))
    ) {
      return get(details, lead_status_key);
    }
    if (details) {
      return details;
    }
  }
  return false;
}
export function generatePayNowFormData(
  masterData,
  userDetail,
  clientInfo,
  auth_details,
  formData,
  promoCodeDetails,
  paymentDetails,
  isCounselorAccessActive,
  counselorDetails
) {
  let data = {};
  let pricingCriterion =
    !isNil(get(masterData, "pricingCriterion")) &&
    !isEmpty(get(masterData, "pricingCriterion"))
      ? get(masterData, "pricingCriterion")
      : "";
  let selectedCourses = !isNil(
    get(formData, HARD_CODED_FIELD_KEYS.SELECTED_COURSE_FOR_PAYMENT)
  )
    ? get(formData, HARD_CODED_FIELD_KEYS.SELECTED_COURSE_FOR_PAYMENT)
    : getSelectedCourseIds(formData, masterData);
  let totalAmount = !isNil(
    get(formData, HARD_CODED_FIELD_KEYS.TOTAL_DISCOUNTED_AMOUNT_TO_PAY)
  )
    ? get(formData, HARD_CODED_FIELD_KEYS.TOTAL_DISCOUNTED_AMOUNT_TO_PAY)
    : !isNil(get(formData, HARD_CODED_FIELD_KEYS.TOTAL_AMOUNT_TO_PAY))
    ? get(formData, HARD_CODED_FIELD_KEYS.TOTAL_AMOUNT_TO_PAY)
    : getTotalAmount(selectedCourses, userDetail, masterData);
  let paymentModeId =
    formData && !isNil(get(formData, HARD_CODED_FIELD_KEYS.ZERO_AMOUNT_TO_PAY))
      ? !isNil(
          get(formData, HARD_CODED_FIELD_KEYS.ZERO_AMOUNT_TO_PAYMENT_METHOD_ID)
        )
        ? get(formData, HARD_CODED_FIELD_KEYS.ZERO_AMOUNT_TO_PAYMENT_METHOD_ID)
        : 1
      : formData && !!formData.paymentMethod && formData.paymentMethod;
  paymentModeId = Array.isArray(paymentModeId)
    ? paymentModeId[0]
    : paymentModeId;
  if (!totalAmount && false) {
    alert("Sorry, Zero or negative amount to pay is not allowed."); //put this message in english json
    return false;
  } else {
    data[HARD_CODED_FIELD_KEYS.FEES_TYPE] =
      !isNil(document.getElementById(HARD_CODED_FIELD_KEYS.FEES_TYPE)) &&
      !isNil(document.getElementById(HARD_CODED_FIELD_KEYS.FEES_TYPE).value) &&
      !isEmpty(document.getElementById(HARD_CODED_FIELD_KEYS.FEES_TYPE).value)
        ? document.getElementById(HARD_CODED_FIELD_KEYS.FEES_TYPE).value
        : 1;
    data[HARD_CODED_FIELD_KEYS.FEES_TYPE] = 1; // for course fees fix 1 need to send for payment
    if (clientInfo && clientInfo.Info && !!clientInfo.Info.clientId) {
      data["clientId"] = clientInfo.Info.clientId;
    }

    if (clientInfo && clientInfo.Info && !!clientInfo.Info.authToken) {
      data["authToken"] = clientInfo.Info.authToken;
    }
    set(data, "cid", "");
    set(data, "lid", "");
    if (
      isCounselorAccessActive &&
      !isNil(counselorDetails) &&
      !!get(counselorDetails, "id")
    ) {
      !!get(counselorDetails, "id") &&
        set(data, "cid", get(counselorDetails, "id"));
      !!get(userDetail, "lead.id") && set(data, "lid", userDetail.lead.id);
    }
    if (clientInfo && clientInfo.Info && !!clientInfo.Info.source) {
      data["source"] = clientInfo.Info.source;
    }
    if (clientInfo && clientInfo.Info && !!clientInfo.Info.alias) {
      data["alias"] = clientInfo.Info.alias;
    }
    data["param1"] = clientInfo && !!get(clientInfo,`paymentDetails.paymentFormRequestParametersMapping.param1`) &&!isNil(get(userDetail,`${clientInfo.paymentDetails.paymentFormRequestParametersMapping.param1}`)) ? get(userDetail,`${clientInfo.paymentDetails.paymentFormRequestParametersMapping.param1}`) : "";
    /*if (
      clientInfo &&
      clientInfo.Info &&
      !!clientInfo.Info.clientId &&
      !!selectedCourses &&
      !!totalAmount
    ) {
      data["amt"] = totalAmount;
    }*/
    if (
      clientInfo &&
      clientInfo.Info &&
      !!clientInfo.Info.clientId &&
      !!selectedCourses
    ) {
      //  data["amt"] = totalAmount;
    }
    
    if (
      clientInfo &&
      clientInfo.Info &&
      !!clientInfo.Info.clientId &&
      !!selectedCourses
    ) {
      // data["actualAmount"] = actualTotalAmount;
    }

    if (
      !isNil(paymentDetails) &&
      !isNil(get(paymentDetails, "pId")) &&
      Array.isArray(get(paymentDetails, "pId")) &&
      get(paymentDetails, "pId").length
    ) {
      data["pId"] = get(paymentDetails, "pId");
    }
    if (userDetail && userDetail.user && !!userDetail.user.prn) {
      data[STORAGE_KEY.PRN] = userDetail.user.prn;
    }
    if (userDetail && userDetail.user && !!userDetail.user.email) {
      data["email"] = userDetail.user.email;
    }
    data["fatherName"] =
      userDetail && userDetail.user && !!userDetail.user.fathersName
        ? userDetail.user.fathersName
        : "";
    if (userDetail && userDetail.user && !!userDetail.user.mobileNumber) {
      data["mobile"] = userDetail.user.mobileNumber;
    }
    if (userDetail && userDetail.lead && !!userDetail.lead.id) {
      data["leadId"] = userDetail.lead.id;
    }
    if (userDetail && userDetail.lead && !!userDetail.lead[STORAGE_KEY.APPLICATION_FORM_NUMBER]) {
      data["appFormNumber"] = userDetail.lead[STORAGE_KEY.APPLICATION_FORM_NUMBER];
    }
    if (userDetail && userDetail.user && !!userDetail.user.id) {
      data["userId"] = userDetail.user.id;
    }
    if (userDetail && masterData && !!selectedCourses) {
      data["courses"] = selectedCourses;
    }

    if (!!pricingCriterion) {
      let entityCollectionName = !isNil(masterData) && getMasterDataByKey(`${pricingCriterion.substring(0, 1).toUpperCase()}${pricingCriterion.substring(1)}`,masterData);
      if (!!userDetail && !!selectedCourses && checkIfArray(entityCollectionName)) {
        data["courseName"] = map(
            filter(entityCollectionName, (item) => {
              return selectedCourses.includes(item.id);
            }),
            "name"
          ).join();
      } else {
        data["courseName"] = "";
      }
    } else {
      data["courseName"] = "";
    }

    data["E1Name"] = "";
    
    const entity1Collection = !isNil(masterData) && getMasterDataByKey(`Entity1`,masterData);
    if (
      userDetail &&
      checkIfArray(get(userDetail, "lead.entity1Id")) &&
      checkIfArray(entity1Collection)
    ) {
        data["E1Name"] = map(
          filter(entity1Collection, (item) => {
            return (userDetail.lead.entity1Id).includes(item.id);
          }),
          "name"
        ).join();
    }

    data["E2Name"] = "";
    const entity2Collection = !isNil(masterData) && getMasterDataByKey(`Entity2`,masterData);
    if(pricingCriterion === "entity2"){
      data["E2Name"] = data["courseName"];
    }else if (
      userDetail &&
      checkIfArray(get(userDetail, "lead.entity2Id")) &&
      checkIfArray(entity2Collection)
    ) {
      if(checkIfArray(entity2Collection)){
        data["E2Name"] = map(
          filter(entity2Collection, (item) => {
            return (userDetail.lead.entity2Id).includes(item.id);
          }),
          "name"
        ).join();
      }
      
    }

    data["E3Name"] = "";
    
    const entity3Collection = !isNil(masterData) && getMasterDataByKey(`Entity3`,masterData);
    if(pricingCriterion === "entity3"){
      data["E3Name"] = data["courseName"];
    }else if (
      userDetail &&
      checkIfArray(get(userDetail, "lead.entity3Id")) &&
      checkIfArray(entity3Collection)
    ) {
      data["E3Name"] = map(
        filter(entity3Collection, (item) => {
          return (userDetail.lead.entity3Id).includes(item.id);
        }),
        "name"
      ).join();
    }

    data["E4Name"] = "";
    
    const entity4Collection = !isNil(masterData) && getMasterDataByKey(`Entity4`,masterData);
    if(pricingCriterion === "entity4"){
      data["E4Name"] = data["courseName"];
    }else if (
      userDetail &&
      checkIfArray(get(userDetail, "lead.entity4Id")) &&
      checkIfArray(entity4Collection)
    ) {
      data["E4Name"] = map(
        filter(entity4Collection, (item) => {
          return (userDetail.lead.entity4Id).includes(item.id);
        }),
        "name"
      ).join();
    }
    if (paymentModeId) {
      data["paymentModeId"] = paymentModeId;
    }
    data["promoCode"] =
      promoCodeDetails && !!promoCodeDetails["promoCode"]
        ? promoCodeDetails["promoCode"]
        : "";
    let mappedSuccessAndFailStatus = getMappedSuccessAndFailStatus(
      paymentModeId,
      clientInfo
    );
    if (
      !mappedSuccessAndFailStatus ||
      !mappedSuccessAndFailStatus.fStatus ||
      !mappedSuccessAndFailStatus.sStatus
    ) {
      logError(
        "Mapping of selected payment mode and it's Success and Fail status is not configured in clientconfig json."
      );
    } else {
      //mappedSuccessAndFailStatus;
      let successStatusDetails =
        masterData &&
        clientInfo &&
        getStatusIdAndReasonIds(
          mappedSuccessAndFailStatus.sStatus,
          masterData,
          clientInfo
        );
      if (
        masterData &&
        clientInfo &&
        successStatusDetails &&
        !!successStatusDetails.statusId &&
        !!successStatusDetails.reasonId
      ) {
        data["sStatus"] = successStatusDetails.statusId;
        data["sReason"] = successStatusDetails.reasonId;
      }
      let failStatusDetails =
        masterData &&
        clientInfo &&
        getStatusIdAndReasonIds(
          mappedSuccessAndFailStatus.fStatus,
          masterData,
          clientInfo
        );
      if (
        masterData &&
        clientInfo &&
        failStatusDetails &&
        !!failStatusDetails.statusId &&
        !!failStatusDetails.reasonId
      ) {
        data["fStatus"] = failStatusDetails.statusId;
        data["fReason"] = failStatusDetails.reasonId;
      }
      let pendingStatusDetails =
        masterData &&
        clientInfo &&
        getStatusIdAndReasonIds(
          mappedSuccessAndFailStatus.pStatus,
          masterData,
          clientInfo
        );
      if (
        masterData &&
        clientInfo &&
        pendingStatusDetails &&
        !!pendingStatusDetails.statusId &&
        !!pendingStatusDetails.reasonId
      ) {
        data["pStatus"] = pendingStatusDetails.statusId;
        data["pReason"] = pendingStatusDetails.reasonId;
      }else{
        data["pStatus"] = "";
        data["pReason"] = "";
      }
    }
    let existingINST = !!OfflineStorage.getItem(
      STORAGE_KEY.INST,
      STORAGE_TYPE.LOCAL
    )
      ? OfflineStorage.getItem(STORAGE_KEY.INST, STORAGE_TYPE.LOCAL)
      : null;
    if (
      masterData &&
      !!masterData.applicationFormCriteria &&
      !!existingINST &&
      !isEmpty(existingINST)
    ) {
      data[STORAGE_KEY.APP_CRITERION] = parseInt(existingINST);
    } else {
      data[STORAGE_KEY.APP_CRITERION] = "";
    }
    if(masterData && pricingCriterion){
      const collection = getMasterDataByKey(capitalize(pricingCriterion),masterData);
      if(checkIfArray(collection)){
        const entityObj = collection.find(ele => data.courses.includes(ele.id));
        if(checkIfObject(entityObj)){
          data[STORAGE_KEY.MAPPED_CODE] = entityObj.mappedCode;
        }
      }
    }
    /*UKC code - COMMENTED FOR FUTHER USE  */
    /**
     * UKC details added for multi lead journey
     */
    let UKC_Details = getUKCDetails(masterData, userDetail);
    UKC_Details = UKC_Details
      ? UKC_Details
      : {
          [STORAGE_KEY.UKC_URL_PARAMETER_KEY]: "",
          [STORAGE_KEY.UKC_VALUE_URL_PARAMETER_KEY]: "",
        };
    Object.assign(data, UKC_Details);
    /* END of UKC update */
    if (
      userDetail &&
      userDetail.user &&
      (!!userDetail.user.firstName || !!userDetail.user.lastName)
    ) {
      let names = [];
      !!userDetail.user.firstName && names.push(userDetail.user.firstName);
      !!userDetail.user.lastName && names.push(userDetail.user.lastName);
      data["name"] = names.join(" ");
    }
    let prefCourseInfo = get(paymentDetails, HARD_CODED_FIELD_KEYS.PREF_COURSES_INFO);
    const allPaidPaymentDetails = getPaidEntitiesIds(userDetail, clientInfo);
    if(checkIfArray(prefCourseInfo)){
      let preferredCourseDetails = [];
      const prefCourseInfoLen = prefCourseInfo.length;
      for(let i=0; i<prefCourseInfoLen; i++){
        const ele = prefCourseInfo[i];
        if(checkIfArray(allPaidPaymentDetails)){
          let paidEntries = allPaidPaymentDetails.find(entry => entry.entityId == ele.id);
          if(checkIfObject(paidEntries)){
            continue;
          }
        }
        if(!(data["pId"].includes(ele.id))){
          continue;
        }
        preferredCourseDetails.push({
          PrefId: ele.prefId,
          Id: ele.id,
          MasterKey: ele.masterKey ? ele.masterKey : capitalize(pricingCriterion)
        })
      }
      data[HARD_CODED_FIELD_KEYS.PREF_COURSES_INFO] = JSON.stringify(preferredCourseDetails);
    }
    if(checkIfObject(formData) && paymentDetails){
      let updatedVal = formData[HARD_CODED_FIELD_KEYS.CURRENCY_FIELD] || "";
      if(checkIfObject(updatedVal) && !Array.isArray(updatedVal)){
        updatedVal = updatedVal.ISOCode
      }
      updatedVal = updatedVal && updatedVal.toString();
      if(updatedVal === "INR"){
        updatedVal = "";
      }
      data["currency"] = updatedVal;
    }
    return data;
  }
}
export function getTodayDataForPaymentDetails() {
  var today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1;
  let yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "/" + mm + "/" + yyyy;
}
export function generateListFromObject(
  params,
  className,
  excludeKeys,
  masterData
) {
  if(!params["paymentDate"])
  params["paymentDate"] = getTodayDataForPaymentDetails();

  if (params && Object.keys(params).length > 0) {
    const modesOfPaymentCollection = !isNil(masterData) && getMasterDataByKey(`ModesOfPayment`,masterData);
    let modeOfPaymentDetail = checkIfArray(modesOfPaymentCollection) && params && !isEmpty(params["paymentModeId"])
        ? find(modesOfPaymentCollection, {
            id: parseInt(params["paymentModeId"]),
          })
        : null;
    params["paymentModeId"] =
      !isEmpty(modeOfPaymentDetail) && !isEmpty(modeOfPaymentDetail["name"])
        ? modeOfPaymentDetail["name"]
        : params["paymentModeId"];
    params["isSuccess"] =
      !isEmpty(params["isSuccess"]) &&
      (params["isSuccess"] === "True" ||
        params["isSuccess"] === "true" ||
        params["isSuccess"] === "1" ||
        params["isSuccess"] === 1)
        ? getLang("PaymentSuccessStatus","Success") 
        : getLang("PaymentFailStatus","Failed");
    /*let allowedKeys =
      excludeKeys && Array.isArray(excludeKeys) && excludeKeys.length > 0
        ? difference(Object.keys(params), excludeKeys)
        : Object.keys(params);*/
    /**
         *
         *
Transaction id: 56c9bb9148f27b5b
Mode of Payment: 1
         Amount: 518
global.payments.isSuccess: Success
Date of Payment: 22/10/2019
         */
    let listItems = [];
    if (!isEmpty(params)) {
      if (!isEmpty(params["transactionId"])) {
        listItems.push(
          <li key={listItems.length + 1}>
            <strong>{getLang("global.payments.transactionId")}</strong>
            {": "}
            {params["transactionId"]}
          </li>
        );
      }
      if (!isEmpty(params["paymentModeId"])) {
        listItems.push(
          <li key={listItems.length + 1}>
            <strong>{getLang("global.payments.paymentModeId")}</strong>
            {": "}
            {params["paymentModeId"]}
          </li>
        );
      }
      if (!isEmpty(params["amt"])) {
        listItems.push(
          <li key={listItems.length + 1}>
            <strong>{getLang("global.payments.amt")}</strong>
            {": "}
            {params["amt"]}
          </li>
        );
      }
      if (!isEmpty(params["isSuccess"])) {
        let lang_text = params["isSuccess"];
        if (
          lang_text === "Success" &&
          !!getLang("PaymentSuccessStatus","")
        ) {
          lang_text = getLang("PaymentSuccessStatus");
        } else if (
          lang_text === "Failed" &&
          !!getLang("PaymentFailStatus","")
        ) {
          lang_text = getLang("PaymentFailStatus");
        }
        listItems.push(
          <li key={listItems.length + 1}>
            <strong>{getLang("global.payments.isSuccess")}</strong>
            {": "}
            <span
              className={"payment-" + params["isSuccess"]}
              dangerouslySetInnerHTML={{
                __html: lang_text,
              }}
            />
          </li>
        );
      }
      if (!isEmpty(params["paymentDate"])) {
        listItems.push(
          <li key={listItems.length + 1}>
            <strong>{getLang("global.payments.paymentDate")}</strong>
            {": "}
            {params["paymentDate"]}            
          </li>
        );
      }
    }    
    return listItems ? (
      <ul className={!!className ? className : undefined}>{listItems}</ul>
    ) : null;
  }
  return null;
}
export function generatePaymentDetailList(params, masterData) {
  let modesOfPayment = !isNil(masterData) && getMasterDataByKey("ModesOfPayment", masterData);
  if (params && Object.keys(params).length > 0) {
    let obj = {};
    obj = Object.keys(params).map((key) => {
      switch (key) {
        case "paymentModeId": {
          let name = checkIfArray(modesOfPayment) && getNameById(params[key], modesOfPayment);
          return {
            value: !!name ? name : params[key],
            label: getLang("form.fields.paymentMethod.title"),
          };
        }
        default: {
          return null;
        }
      }
    });
    return obj && Object.keys(obj).length;
  }
  return null;
}
export function validateMappedLeadStatus(clientInfo, masterData) {
  if (clientInfo && masterData) {
    let leadStatuses = getMasterDataByKey("LeadStatuses", masterData);
    let leadReasons = getMasterDataByKey("LeadReasons", masterData);
    let modesOfPayment = get(clientInfo, "paymentDetails.ModesOfPayment");
    let mappedStatusToStep = get(clientInfo,"LeadstatusDetails.applicationFormStatusMapping");

    if (!checkIfArray(leadStatuses)) {
      logError(new Error("LeadStatuses in masterdata is blank"));
    }
    if (!checkIfArray(leadReasons)) {
      logError(new Error("LeadReasons in masterdata is blank"));
    }
    if (!checkIfArray(modesOfPayment)) {
      logError(
        new Error(
          "ModeOfPayment and lead status mapping is missing in client configuration json. This is mandatory because it require update status and reason on any mode of payment success/fail"
        )
      );
    }
    if (!checkIfArray(mappedStatusToStep)) {
      logError(
        new Error(
          "mappedStatusToStep for lead status mapping with each step completion is missing in client configuration json. This is mandatory because it require for update lead status while change/navigate step"
        )
      );
    }
    if (leadStatuses && leadReasons && mappedStatusToStep) {
      mappedStatusToStep.map((item) => {
        let foundStatus =
          !!item.LeadStatusTitle &&
          find(leadStatuses, { name: item.LeadStatusTitle });
        if (!foundStatus) {
          if (!!item.LeadStatusTitle) {
            logError(
              new Error(
                "Status: '" +
                  item.LeadStatusTitle +
                  "' not found in master data."
              )
            );
          } else if (!!item.key) {
            logError(
              new Error(
                "Status not mapped to '" + item.key + "' in client config json."
              )
            );
          } else {
            logError(
              new Error(
                "Status not mapped to '" + item.key + "' in client config json."
              )
            );
          }
        } else {
          let foundReason = find(leadReasons, { statusId: foundStatus.id });
          if (!foundReason) {
            logError(
              new Error(
                "Mapped `Reason` for `" +
                  item.LeadStatusTitle +
                  "` not found in master data"
              )
            );
          } else {
            /*logInfo(
              "Mapped `Reason` `" +
                foundReason.name +
                "` for `" +
                item.LeadStatusTitle +
                "` found in master data"
            );*/
          }
        }
        return false;
      });
    }
    if (leadStatuses && leadReasons && modesOfPayment) {
      let successStatuses = map(modesOfPayment, "sStatus");
      let failStatuses = map(modesOfPayment, "fStatus");
      let status = union(successStatuses, failStatuses);

      status.map((item) => {
        let foundStatus = find(leadStatuses, { name: item });
        if (!foundStatus) {
          logError(
            new Error("Status: '" + item + "' not found in master data")
          );
        } else {
          let foundReason = find(leadReasons, { statusId: foundStatus.id });
          if (!foundReason) {
            logError(
              new Error(
                "Mapped `Reason` for `" + item + "` not found in master data"
              )
            );
          } else {
            /*logInfo(
              "Mapped `Reason` `" +
                foundReason.name +
                "` for `" +
                item +
                "` found in master data"
            );*/
          }
        }
        return true;
      });
    } else {
      //logInfo("ALL MAPPING WORKING CONFIG CORRECTLY");
    }

    /*logInfo(
      "***********    Checking mapped lead status and there reason are exists in master data  ***********"
    );*/
  }
}
/** Notification */
export function notify(message, config) {
  config && Object.keys(config).length
    ? toast(message, config)
    : toast(message);
}

/**Replace token used in JSON with value */
export function replaceTokenWithValue(token, userDetail, masterData, clientInfo, isCounselorAccessActive) {
  const { emailMobileVerification, enableMasking } = clientInfo ? clientInfo : {};
  const verificationData = get(userDetail, "lead.verificationData") ? get(userDetail, "lead.verificationData") : [];
  let isPrimaryEmailVerified = false;
  let isPrimaryMobileVerified = false;
  checkIfArray(verificationData) && verificationData.forEach(ele => {
    const { keyId, isVerified, value } = ele;
    if(keyId === 1 && isVerified && userDetail && userDetail.user && userDetail.user.email === value){
      isPrimaryEmailVerified = true
    }
    if(keyId === 5 && isVerified && userDetail && userDetail.user && userDetail.user.mobileNumber === value){
      isPrimaryMobileVerified = true
    }
  })
  const { verifyEmail, verifyMobile, editEmail, editMobile } = emailMobileVerification ? emailMobileVerification : {};
  switch (token) {
    case CONTENT_TOKEN.APPLICATION_NUMBER: {
      return userDetail &&
        userDetail.lead &&
        !isEmpty(userDetail.lead.applicationFormNumber)
        ? userDetail.lead.applicationFormNumber
        : null;
    }
    case CONTENT_TOKEN.GENDER: {
      const genderCollection = !isNil(masterData) && getMasterDataByKey(`Gender`,masterData);
      const mappedGender = userDetail && checkIfArray(genderCollection) && !!(get(userDetail,`user.gender`))?.trim() &&
      find(genderCollection, {alias: userDetail.user.gender});
      return !!mappedGender && !!mappedGender.name ? mappedGender.name: "";
    }
    case CONTENT_TOKEN.APPLICATION_STATUS: {
      const leadStatuses = !isNil(masterData) && getMasterDataByKey(`LeadStatuses`,masterData);
      const mappedStatus = userDetail &&
      userDetail.lead &&
      checkIfArray(leadStatuses) &&
      !isEmpty(userDetail.lead.statusId) &&
      find(leadStatuses, {
        id: parseInt(userDetail.lead.statusId),
      });
      return !!mappedStatus && !!mappedStatus.name ? mappedStatus.name : "";
    }
    case CONTENT_TOKEN.COURSE_APPLIED:
      let courseIds =
        userDetail &&
        masterData &&
        !isEmpty(masterData.pricingCriterion) &&
        !isEmpty(userDetail.lead) &&
        !isEmpty(
          userDetail.lead[
            EntityFieldNameByCriteriaValue[masterData.pricingCriterion]
          ]
        )
          ? userDetail.lead[
              EntityFieldNameByCriteriaValue[masterData.pricingCriterion]
            ]
          : null;
      if (!isEmpty(courseIds)) {
        const pricingList = !isNil(masterData) && getMasterDataByKey(`PricingList`,masterData);
        let pricingListIds = checkIfArray(pricingList) &&
          map(pricingList, "entityId");
        let coursesWithPricing = intersection(courseIds, pricingListIds);
        let courseNames =
          masterData &&
          masterData.pricingCriterion &&
          map(
            filter(
              getMasterDataByKey(
                MasterDataCollectionByCriteriaValue[
                  masterData.pricingCriterion
                ],
                masterData
              ),
              function (o) {
                return coursesWithPricing.includes(o.id);
              }
            ),
            "name"
          );
        return !isEmpty(courseNames)
          ? "<ul class='course-list'><li>" +
              courseNames.join("</li><li>") +
              "</li></ul>"
          : null;
      }
      return null;

    case CONTENT_TOKEN.LOGGED_USER_ENTITY1:
      return getEntityNamesByKey("entity1", userDetail, masterData);

    case CONTENT_TOKEN.LOGGED_USER_ENTITY2:
      return getEntityNamesByKey("entity2", userDetail, masterData);

    case CONTENT_TOKEN.LOGGED_USER_ENTITY3:
      return getEntityNamesByKey("entity3", userDetail, masterData);

    case CONTENT_TOKEN.LOGGED_USER_ENTITY4:
      return getEntityNamesByKey("entity4", userDetail, masterData);

    case CONTENT_TOKEN.LOGGED_USER_EMAIL: {
      if(userDetail && userDetail.user && !isEmpty(userDetail.user.email)){
        let updatedEmail = "";
        const { email } = enableMasking || {};
        if(email && isCounselorAccessActive){
          updatedEmail = replaceEmailWithStars(userDetail.user.email);
        }else{
          updatedEmail = userDetail.user.email
        }
        const verifyEmailIcon = verifyEmail ? `<img id="verifyEmail" class="${isPrimaryEmailVerified && "pe-none"}" alt="" src="${isPrimaryEmailVerified ? VerifiedIcon : NotVerifiedIcon}" title="${verifyEmail && (isPrimaryEmailVerified ? "Email Id Verified" : "Email Id not Verified. Click to Verify")}"/>` : '';

        const editEmailIcon = (editEmail && EditIcon) ? `<img id="editEmail" alt="" src="${EditIcon}" title="${editEmail && "Edit your Email Id"}"/>` :  ``;

        return `<div class="d-flex align-items-center"><div class="email-text" title="${updatedEmail}">${updatedEmail}</div><div class="verify-change-container">${verifyEmailIcon}${editEmailIcon}</div></div>`;
      }
      return null;
    }

    case CONTENT_TOKEN.LOGGED_USER_MOBILE: {
      if(userDetail && userDetail.user && !isEmpty(userDetail.user.mobileNumber)){
        let updatedMobileNumber = "";
        const { mobile } = enableMasking || {};
        if(mobile && isCounselorAccessActive){
          updatedMobileNumber = replaceMobileWithStars(userDetail.user.mobileNumber);
        }else{
          updatedMobileNumber = userDetail.user.mobileNumber
        }

        const verifyMobileNumberIcon = verifyMobile ? `<img id="verifyMobile" class="${isPrimaryMobileVerified && "pe-none"}" alt="" src="${isPrimaryMobileVerified ? VerifiedIcon : NotVerifiedIcon}" title="${verifyMobile && (isPrimaryMobileVerified ? "Mobile Number Verified" : "Mobile Number not Verified. Click to Verify")}"/>` : "";

        const editMobileNumberIcon = (editMobile && EditIcon) ? `<img id="editMobile" alt="" src="${EditIcon}" title="${editMobile && "Edit your Mobile Number"}"/>` : "";

        return `<div class="d-flex align-items-center"><div class="mobile-text" title="${updatedMobileNumber}">${updatedMobileNumber}</div><div class="verify-change-container">${verifyMobileNumberIcon}${editMobileNumberIcon}</div></div>`;
      }
      return null;
    }

    case CONTENT_TOKEN.LOGGED_USER_FULL_NAME: {
      var names = [];
      if(userDetail && userDetail.user){
        userDetail.user.firstName && names.push(userDetail.user.firstName);        
        userDetail.user.lastName && names.push(userDetail.user.lastName);
      }
      return names.length>0 ? `${names.join(" ")}` : null;
    }

    case CONTENT_TOKEN.LOGGED_USER_FIRST_NAME: {
      return userDetail &&
        userDetail.user &&
        !isEmpty(userDetail.user.firstName) ?
        `${userDetail.user.firstName}` 
        : null;
    }

    case CONTENT_TOKEN.TIME_STAMP: {
      let date = new Date();
      date = date.toUTCString()
      return moment(date).format("YYYYMMDDhhmmss");
    }

    default: {
      return token;
    }
  }
}

export function getEntityNamesByKey(key, userDetail, masterData) {
  let ids =
    userDetail &&
    masterData &&
    !isEmpty(key) &&
    !isEmpty(userDetail.lead) &&
    !isEmpty(userDetail.lead[EntityFieldNameByCriteriaValue[key]])
      ? userDetail.lead[EntityFieldNameByCriteriaValue[key]]
      : null;

  if (!isEmpty(ids)) {
    let entityNames =
      masterData &&
      key &&
      map(
        filter(
          getMasterDataByKey(
            MasterDataCollectionByCriteriaValue[key],
            masterData
          ),
          function (o) {
            return ids.includes(o.id);
          }
        ),
        "name"
      );
    return !isEmpty(entityNames)
      ? "<ul class='course-list'><li>" +
          entityNames.join("</li><li>") +
          "</li></ul>"
      : "";
  }
  return "";
}
export function replaceAllContentTokens(content, userDetail, masterData, clientInfo=null, isCounselorAccessActive=false) {
  let arr = [];
  Object.keys(CONTENT_TOKEN).map((key) => {
    arr = content.split(CONTENT_TOKEN[key]);
    if (arr.length > 1) {
      let val = replaceTokenWithValue(
        CONTENT_TOKEN[key],
        userDetail,
        masterData,
        clientInfo,
        isCounselorAccessActive
      );
      content = arr.join(val);
    }
    return true;
  });
  return content;
}

export function generatePayNowCourseFeeFormData(
  masterData,
  userDetail,
  clientInfo,
  auth_details,
  formData,
  promoCodeDetails,
  lead_status_key,
  paymentDetails,
  isCounselorAccessActive,
  counselorDetails
) {
  let data = {};
  let pricingCriterion =
    !isNil(get(masterData, "pricingCriterion")) &&
    !isEmpty(get(masterData, "pricingCriterion"))
      ? get(masterData, "pricingCriterion")
      : "";
  let selectedCourses = !isNil(
    get(formData, HARD_CODED_FIELD_KEYS.SELECTED_COURSE_FOR_PAYMENT_CF)
  )
    ? get(formData, HARD_CODED_FIELD_KEYS.SELECTED_COURSE_FOR_PAYMENT_CF)
    : getSelectedCourseIds(formData, masterData);
  let totalAmount = !isNil(
    get(formData, HARD_CODED_FIELD_KEYS.TOTAL_DISCOUNTED_AMOUNT_TO_PAY_CF)
  )
    ? get(formData, HARD_CODED_FIELD_KEYS.TOTAL_DISCOUNTED_AMOUNT_TO_PAY_CF)
    : !isNil(get(formData, HARD_CODED_FIELD_KEYS.TOTAL_AMOUNT_TO_PAY_CF))
    ? get(formData, HARD_CODED_FIELD_KEYS.TOTAL_AMOUNT_TO_PAY_CF)
    : getTotalAmount(selectedCourses, userDetail, masterData);
  let paymentModeId =
    formData &&
    !isNil(get(formData, HARD_CODED_FIELD_KEYS.ZERO_AMOUNT_TO_PAY_CF))
      ? !isNil(
          get(
            formData,
            HARD_CODED_FIELD_KEYS.ZERO_AMOUNT_TO_PAYMENT_METHOD_ID_CF
          )
        )
        ? get(
            formData,
            HARD_CODED_FIELD_KEYS.ZERO_AMOUNT_TO_PAYMENT_METHOD_ID_CF
          )
        : 1
      : formData &&
        !!formData[HARD_CODED_FIELD_KEYS.PAYMENT_MODE_CF] &&
        formData[HARD_CODED_FIELD_KEYS.PAYMENT_MODE_CF];
  paymentModeId = Array.isArray(paymentModeId)
    ? paymentModeId[0]
    : paymentModeId;
  if (!totalAmount && false) {
    alert("Sorry, Zero or negative amount to pay is not allowed."); //put this message in english json
    return false;
  } else {
    data[HARD_CODED_FIELD_KEYS.FEES_TYPE] =
      !isNil(document.getElementById(HARD_CODED_FIELD_KEYS.FEES_TYPE_CF)) &&
      !isNil(
        document.getElementById(HARD_CODED_FIELD_KEYS.FEES_TYPE_CF).value
      ) &&
      !isEmpty(
        document.getElementById(HARD_CODED_FIELD_KEYS.FEES_TYPE_CF).value
      )
        ? document.getElementById(HARD_CODED_FIELD_KEYS.FEES_TYPE_CF).value
        : 2;
    if (clientInfo && clientInfo.Info && !!clientInfo.Info.clientId) {
      data["clientId"] = clientInfo.Info.clientId;
    }

    if (clientInfo && clientInfo.Info && !!clientInfo.Info.authToken) {
      data["authToken"] = clientInfo.Info.authToken;
    }
    set(data, "cid", "");
    set(data, "lid", "");
    if (
      isCounselorAccessActive &&
      !isNil(counselorDetails) &&
      !!get(counselorDetails, "id")
    ) {
      !!get(counselorDetails, "id") &&
        set(data, "cid", get(counselorDetails, "id"));
      !!get(userDetail, "lead.id") && set(data, "lid", userDetail.lead.id);
    }
    if (clientInfo && clientInfo.Info && !!clientInfo.Info.source) {
      data["source"] = clientInfo.Info.source;
    }
    if (clientInfo && clientInfo.Info && !!clientInfo.Info.alias) {
      data["alias"] = clientInfo.Info.alias;
    }
    data["param1"] = clientInfo && !!get(clientInfo,`paymentDetails.paymentFormRequestParametersMapping.param1`) &&!isNil(get(userDetail,`${clientInfo.paymentDetails.paymentFormRequestParametersMapping.param1}`)) ? get(userDetail,`${clientInfo.paymentDetails.paymentFormRequestParametersMapping.param1}`) : "";
    /*if (
      clientInfo &&
      clientInfo.Info &&
      !!clientInfo.Info.clientId &&
      !!selectedCourses &&
      !!totalAmount
    ) {
      data["amt"] = totalAmount;
    }*/
    if (
      clientInfo &&
      clientInfo.Info &&
      !!clientInfo.Info.clientId &&
      !!selectedCourses
    ) {
      // data["amt"] = totalAmount;
    }

    if (
      clientInfo &&
      clientInfo.Info &&
      !!clientInfo.Info.clientId &&
      !!selectedCourses
    ) {
      //  data["actualAmount"] = actualTotalAmount;
    }
    if (
      !isNil(paymentDetails) &&
      !isNil(get(paymentDetails, "pId")) &&
      Array.isArray(get(paymentDetails, "pId")) &&
      get(paymentDetails, "pId").length
    ) {
      data["pId"] = get(paymentDetails, "pId");
    }
    if (userDetail && userDetail.user && !!userDetail.user.prn) {
      data[STORAGE_KEY.PRN] = userDetail.user.prn;
    }
    if (userDetail && userDetail.user && !!userDetail.user.email) {
      data["email"] = userDetail.user.email;
    }
    if (userDetail && userDetail.lead && !!userDetail.lead[STORAGE_KEY.APPLICATION_FORM_NUMBER]) {
      data["appFormNumber"] = userDetail.lead[STORAGE_KEY.APPLICATION_FORM_NUMBER];
    }
    data["fatherName"] =
      userDetail && userDetail.user && !!userDetail.user.fathersName
        ? userDetail.user.fathersName
        : "";
    if (userDetail && userDetail.user && !!userDetail.user.mobileNumber) {
      data["mobile"] = userDetail.user.mobileNumber;
    }
    if (userDetail && userDetail.lead && !!userDetail.lead.id) {
      data["leadId"] = userDetail.lead.id;
    }
    if (userDetail && userDetail.user && !!userDetail.user.id) {
      data["userId"] = userDetail.user.id;
    }
    if (userDetail && masterData && !!selectedCourses) {
      data["courses"] = selectedCourses;
    }
    if (!!pricingCriterion) {
      let entityCollectionName = !isNil(masterData) && getMasterDataByKey(`${pricingCriterion.substring(0, 1).toUpperCase()}${pricingCriterion.substring(1)}`,masterData);
      if (userDetail && checkIfArray(selectedCourses) && checkIfArray(entityCollectionName)) {
        data["courseName"] =
          map(
            filter(entityCollectionName, (item) => {
              return selectedCourses.includes(item.id);
            }),
            "name"
          ).join();
      } else {
        data["courseName"] = "";
      }
    } else {
      data["courseName"] = "";
    }
    data["E1Name"] = "";
    const entity1Collection = !isNil(masterData) && getMasterDataByKey(`Entity1`,masterData);
    if (
      userDetail &&
      checkIfArray(get(userDetail, "lead.entity1Id")) &&
      checkIfArray(entity1Collection)
    ) {
      data["E1Name"] = map(
        filter(entity1Collection, (item) => {
          return (userDetail.lead.entity1Id).includes(item.id);
        }),
        "name"
      ).join();
    }

    data["E2Name"] = "";
    
    const entity2Collection = !isNil(masterData) && getMasterDataByKey(`Entity2`,masterData);
    if(pricingCriterion === "entity2"){
      data["E2Name"] = data["courseName"];
    }else if (
      userDetail &&
      checkIfArray(get(userDetail, "lead.entity2Id")) &&
      checkIfArray(entity2Collection)
    ) {
      data["E2Name"] = map(
        filter(entity2Collection, (item) => {
          return (userDetail.lead.entity2Id).includes(item.id);
        }),
        "name"
      ).join();
    }

    data["E3Name"] = "";
    const entity3Collection = !isNil(masterData) && getMasterDataByKey(`Entity3`,masterData);
    if(pricingCriterion === "entity3"){
      data["E3Name"] = data["courseName"];
    }else if (
      userDetail &&
      checkIfArray(get(userDetail, "lead.entity3Id")) &&
      checkIfArray(entity3Collection)
    ) {
      data["E3Name"] = map(
        filter(entity3Collection, (item) => {
          return (userDetail.lead.entity3Id).includes(item.id);
        }),
        "name"
      ).join();
    } 

    data["E4Name"] = "";
    const entity4Collection = !isNil(masterData) && getMasterDataByKey(`Entity4`,masterData);
    if(pricingCriterion === "entity4"){
      data["E4Name"] = data["courseName"];
    }else if (
      userDetail &&
      checkIfArray(get(userDetail, "lead.entity4Id")) &&
      checkIfArray(entity4Collection)
    ) {
      data["E4Name"] = map(
        filter(entity4Collection, (item) => {
          return (userDetail.lead.entity4Id).includes(item.id);
        }),
        "name"
      ).join();
    }
    if (paymentModeId) {
      data["paymentModeId"] = paymentModeId;
    }
    data["promoCode"] =
      promoCodeDetails && !!promoCodeDetails["promoCode"]
        ? promoCodeDetails["promoCode"]
        : "";
    let mappedSuccessAndFailStatus = getMappedSuccessAndFailStatus(
      paymentModeId,
      clientInfo,
      lead_status_key
    );
    if (
      !mappedSuccessAndFailStatus ||
      !mappedSuccessAndFailStatus.fStatus ||
      !mappedSuccessAndFailStatus.sStatus
    ) {
      logError(
        "Mapping of selected payment mode and it's Success and Fail status is not configured in clientconfig json."
      );
    } else {
      //mappedSuccessAndFailStatus;
      let successStatusDetails =
        masterData &&
        clientInfo &&
        getStatusIdAndReasonIds(
          mappedSuccessAndFailStatus.sStatus,
          masterData,
          clientInfo
        );
      if (
        masterData &&
        clientInfo &&
        successStatusDetails &&
        !!successStatusDetails.statusId &&
        !!successStatusDetails.reasonId
      ) {
        data["sStatus"] = successStatusDetails.statusId;
        data["sReason"] = successStatusDetails.reasonId;
      }
      let failStatusDetails =
        masterData &&
        clientInfo &&
        getStatusIdAndReasonIds(
          mappedSuccessAndFailStatus.fStatus,
          masterData,
          clientInfo
        );
      if (
        masterData &&
        clientInfo &&
        failStatusDetails &&
        !!failStatusDetails.statusId &&
        !!failStatusDetails.reasonId
      ) {
        data["fStatus"] = failStatusDetails.statusId;
        data["fReason"] = failStatusDetails.reasonId;
      }
      
      let pendingStatusDetails =
        masterData &&
        clientInfo &&
        getStatusIdAndReasonIds(
          mappedSuccessAndFailStatus.pStatus,
          masterData,
          clientInfo
        );
      if (
        masterData &&
        clientInfo &&
        pendingStatusDetails &&
        !!pendingStatusDetails.statusId &&
        !!pendingStatusDetails.reasonId
      ) {
        data["pStatus"] = pendingStatusDetails.statusId;
        data["pReason"] = pendingStatusDetails.reasonId;
      }else{
        data["pStatus"] = "";
        data["pReason"] = "";
      }
    }
    let existingINST = !!OfflineStorage.getItem(
      STORAGE_KEY.INST,
      STORAGE_TYPE.LOCAL
    )
      ? OfflineStorage.getItem(STORAGE_KEY.INST, STORAGE_TYPE.LOCAL)
      : null;
    if (
      masterData &&
      !!masterData.applicationFormCriteria &&
      !!existingINST &&
      !isEmpty(existingINST)
    ) {
      data[STORAGE_KEY.APP_CRITERION] = parseInt(existingINST);
    } else {
      data[STORAGE_KEY.APP_CRITERION] = "";
    }
    if(masterData && pricingCriterion){
      const collection = getMasterDataByKey(capitalize(pricingCriterion),masterData); 
      if(checkIfArray(collection)){
        const entityObj = collection.find(ele => data.courses.includes(ele.id));
        if(checkIfObject(entityObj)){
          data[STORAGE_KEY.MAPPED_CODE] = entityObj.mappedCode;
        }
      }
    }
    /**
     * UKC details added for multi lead journey
     */
    let UKC_Details = getUKCDetails(masterData, userDetail);
    UKC_Details = UKC_Details
      ? UKC_Details
      : {
          [STORAGE_KEY.UKC_URL_PARAMETER_KEY]: "",
          [STORAGE_KEY.UKC_VALUE_URL_PARAMETER_KEY]: "",
        };
    Object.assign(data, UKC_Details);
    /* END of UKC update */
    if (
      userDetail &&
      userDetail.user &&
      (!!userDetail.user.firstName || !!userDetail.user.lastName)
    ) {
      let names = [];
      !!userDetail.user.firstName && names.push(userDetail.user.firstName);
      !!userDetail.user.lastName && names.push(userDetail.user.lastName);
      data["name"] = names.join(" ");
    }
    if(checkIfObject(formData) && paymentDetails){
      let updatedVal = formData[HARD_CODED_FIELD_KEYS.CURRENCY_FIELD_CF] || "";
      if(checkIfObject(updatedVal) && !Array.isArray(updatedVal)){
        updatedVal = updatedVal.ISOCode
      }
      updatedVal = updatedVal && updatedVal.toString();
      if(updatedVal === "INR"){
        updatedVal = "";
      }
      data["currency"] = updatedVal;
    }
    return data;
  }
}
export function renameAllProprtyNamebyFirstLetterLowerCase(JSON_Data) {
  Object.keys(JSON_Data).forEach((item) => {
    checkIfArray(JSON_Data[item]) && JSON_Data[item].forEach((citem) => {
      Object.keys(citem).forEach((cItemKey) => {
        if (cItemKey !== cItemKey.charAt(0).toLowerCase() + cItemKey.slice(1)) {
          citem[cItemKey.charAt(0).toLowerCase() + cItemKey.slice(1)] =
            citem[cItemKey];
          delete citem[cItemKey];
        }
      });
    });
  });
  return JSON_Data;
}

export function getUKCDetails(masterData, userDetail) {
  let outputObj = {};
  if (
    !isNil(masterData) &&
    !isNil(get(masterData, STORAGE_KEY.UNIQUE_KEY_CRITERIA)) &&
    !isEmpty(get(masterData, STORAGE_KEY.UNIQUE_KEY_CRITERIA))
  ) {
    set(
      outputObj,
      STORAGE_KEY.UKC_URL_PARAMETER_KEY,
      get(masterData, STORAGE_KEY.UNIQUE_KEY_CRITERIA)
    );
    if (!isNil(userDetail)) {
      let uniqueKeyFieldName =
        EntityFieldNameByCriteriaValue[
          get(outputObj, STORAGE_KEY.UKC_URL_PARAMETER_KEY)
        ];
      if (
        !isNil(get(userDetail, `lead.${uniqueKeyFieldName}`)) &&
        Array.isArray(get(userDetail, `lead.${uniqueKeyFieldName}`)) &&
        get(userDetail, `lead.${uniqueKeyFieldName}`).length &&
        get(userDetail, `lead.${uniqueKeyFieldName}`)[0]
      ) {
        set(
          outputObj,
          STORAGE_KEY.UKC_VALUE_URL_PARAMETER_KEY,
          get(userDetail, `lead.${uniqueKeyFieldName}`)[0]
        );
      }
    }
  }
  return Object.keys(outputObj).length ? outputObj : null;
  //uniqueKeyCriteriaValue=238&uniqueKeyCriteria=entity2
}

/**
 * Convert object to search string paramters
 */
export function convertObjectToSearchParamString(data) {
  if (data && Object.keys(data).length)
    return Object.keys(data)
      .map((key) => `${key}=${encodeURIComponent(data[key])}`)
      .join("&");
  return "";
}

export function generateUniqueFieldByInputType(formConfig) {
  let collectionByInputType = {};
  forEach(get(formConfig, "steps"), function (step, stepKey) {
    forEach(get(step, "config.panels"), function (panel, panelKey) {
      forEach(get(panel, "fields"), function (field, fieldKey) {
        const fieldType =
          isNil(get(field, "type")) || isLodashEmpty(get(field, "type"))
            ? "text"
            : get(field, "type");
        const visible =
          isNil(get(field, "visible")) || !!get(field, "visible")
            ? true
            : false;
        if (
          !!fieldType &&
          // /^[a-zA-Z]+$/.test(fieldType) &&
          visible &&
          fieldType !== FORM_INPUT_UI.HIDDEN &&
          !isNil(get(field, `title`)) &&
          !isLodashEmpty(get(field, `title`))
        ) {
          //visible field found then add in collection
          if (
            !has(collectionByInputType, fieldType) ||
            isNil(has(collectionByInputType, fieldType))
          ) {
            set(collectionByInputType, fieldType, [
              { fieldKey, title: get(field, `title`) },
            ]);
          } else {
            if (
              Array.isArray(collectionByInputType[fieldType]) &&
              isNil(
                find(collectionByInputType[fieldType], { fieldKey: fieldKey })
              )
            ) {
              set(
                collectionByInputType,
                fieldType,
                collectionByInputType[fieldType].concat({
                  fieldKey,
                  title: get(field, `title`),
                })
              );
            }
          }
        }
      });
    });
  });
  return keys(collectionByInputType).length > 0 ? collectionByInputType : null;
}

export const renameFileByToken = (filename, userDetail, masterData) => {
  filename = replaceAllContentTokens(filename, userDetail, masterData);
  return filename;
};
export function replaceTokenOfPDFAPIRequest(
  requestObject,
  leadId,
  clientInfo,
  IsPaymentDone,
  IsEmailSend=false,
  feesType,
  templateHTMLFileName,
  receiptNumber,
  isDebugMode=false
) {
  forEach(Object.keys(requestObject), (key) => {
    switch (requestObject[key]) {
      case "$SOURCE$":
        set(requestObject, key, get(clientInfo, `Info.source`));
        break;
      case "$AUTH_TOKEN$":
        set(requestObject, key, get(clientInfo, `Info.authToken`));
        break;
      case "$INST$":
        !!OfflineStorage.getItem(STORAGE_KEY.INST, STORAGE_TYPE.LOCAL)
          ? set(
              requestObject,
              key,
              parseInt(
                OfflineStorage.getItem(STORAGE_KEY.INST, STORAGE_TYPE.LOCAL)
              )
            )
          : unset(requestObject, key);
        break;
      case "$UKC$":
        !!OfflineStorage.getItem(
          STORAGE_KEY.UKC_VALUE_URL_PARAMETER_KEY,
          STORAGE_TYPE.LOCAL
        )
          ? set(
              requestObject,
              key,
              parseInt(
                OfflineStorage.getItem(
                  STORAGE_KEY.UKC_VALUE_URL_PARAMETER_KEY,
                  STORAGE_TYPE.LOCAL
                )
              )
            )
          : unset(requestObject, key);
        break;
      case "$LEAD_ID$":
        set(requestObject, key, leadId);
      break;
      case "$IS_PAYMENT_DONE$":
        set(requestObject, key, IsPaymentDone);
      break;
      case "$IS_EMAIL_SEND$":
        set(requestObject, key, IsEmailSend);
      break;
      case "$FEES_TYPE$":
        set(requestObject, key, feesType);
      break;
      case "$TEMPLATE_HTML$":
        set(requestObject, key, templateHTMLFileName);
      break;
      case "$IS_DEBUG_MODE$":
        set(requestObject, key, isDebugMode);
      break;
      case "Payment_Receipt_$RECEIPT_NUMBER$":
        const receiptNumberValue = !!receiptNumber?receiptNumber.replace(/[,\/!@#$%^&*'\\;():|[\]+ ]/g,'_'):receiptNumber;
        set(requestObject, key, `Payment_Receipt_${receiptNumberValue}`);
      break;
      case "$RECEIPT_NUMBER$":
        set(requestObject, key, `${receiptNumber}`);
      break;
      default: {
      }
    }
  });
  return requestObject;
  /**
   * Sample object
   * 
   * "apiRequest": {
        "AuthToken": "$AUTH_TOKEN$",
        "IsEmailSend": true,
        "IsPaymentDone": false,
        "Source": "$SOURCE$",
        "inst": "$INST$",
        "leadId": "$LEAD_ID$",
        "ukc": "$UKC$",
        "pdfNameToken": "OFFER_LETTER",
        "templateFileName": "offerLetter_template.html",
        "emailTemplateName": "ApplicationFormEmailPdf"
    }
   */
}

export const addURLParametersAndRoute = (params, history) => {
  if (!!history && params && Object.keys(params).length) {
    let searchParams = {
      [STORAGE_KEY.PRN]: !!OfflineStorage.getItem(
        STORAGE_KEY.PRN,
        STORAGE_TYPE.LOCAL
      )
        ? OfflineStorage.getItem(STORAGE_KEY.PRN, STORAGE_TYPE.LOCAL)
        : undefined,
      [STORAGE_KEY.UKC_VALUE_URL_PARAMETER_KEY]: !!OfflineStorage.getItem(
        STORAGE_KEY.UKC_VALUE_URL_PARAMETER_KEY,
        STORAGE_TYPE.LOCAL
      )
        ? OfflineStorage.getItem(
            STORAGE_KEY.UKC_VALUE_URL_PARAMETER_KEY,
            STORAGE_TYPE.LOCAL
          )
        : undefined,
      [STORAGE_KEY.INST]: !!OfflineStorage.getItem(
        STORAGE_KEY.INST,
        STORAGE_TYPE.LOCAL
      )
        ? OfflineStorage.getItem(STORAGE_KEY.INST, STORAGE_TYPE.LOCAL)
        : undefined,
      [STORAGE_KEY.COUNSELOR_ID]: !!OfflineStorage.getItem(
        STORAGE_KEY.COUNSELOR_ID,
        STORAGE_TYPE.LOCAL
      )
        ? OfflineStorage.getItem(STORAGE_KEY.COUNSELOR_ID, STORAGE_TYPE.LOCAL)
        : undefined,
      [STORAGE_KEY.COUNSELOR_ACCESS_LEAD_ID]: !!OfflineStorage.getItem(
        STORAGE_KEY.COUNSELOR_ACCESS_LEAD_ID,
        STORAGE_TYPE.LOCAL
      )
        ? OfflineStorage.getItem(
            STORAGE_KEY.COUNSELOR_ACCESS_LEAD_ID,
            STORAGE_TYPE.LOCAL
          )
        : undefined,
    };
    forEach(searchParams, (value, key) => {
      !value && unset(searchParams, key);
    });

    Object.keys(searchParams).length &&
      Object.assign(params, {
        search: "?" + convertObjectToSearchParamString(searchParams),
      });
  }
  history.push(params);
};
const replaceTokenInObject= (requestParams,userDetail,masterData,masterDataMapping,requestParamsDataType)=>{
  requestParams=forIn(requestParams,(requestValue,requestKey)=>{
    if(has(userDetail,requestValue)){
     set(requestParams,requestKey,!!get(userDetail,requestValue)?get(userDetail,requestValue):"");
     if(!!get(userDetail,requestValue) && !!masterDataMapping && !isNil(get(masterDataMapping,requestKey))){
        const collection = !isNil(masterData) && getMasterDataByKey(masterDataMapping[requestKey],masterData);
        if(checkIfArray(collection)){
          const mappedMasterDataItem=find(collection,{id:requestParams[requestKey]});
          !!mappedMasterDataItem && !isNil(mappedMasterDataItem.name) && set(requestParams,requestKey,mappedMasterDataItem.name);
        }
     }
    }
    if(!isNil(requestParamsDataType) && has(requestParamsDataType,requestKey)  && !isEmpty(requestParamsDataType,requestKey)&& !isNil(requestParamsDataType,requestKey) && requestParamsDataType[requestKey]=== "jsonString"){
      const nestedObject=replaceTokenInObject(requestParams[requestKey],userDetail,masterData,masterDataMapping,requestParamsDataType);
      !!nestedObject && Object.keys(nestedObject).length>0 &&  set(requestParams,requestKey,JSON.stringify(nestedObject));     
     }
  });
  return requestParams;
}
export const callAPIActions =  async (afterPaymentActions, isPaymentSucces, masterData, userDetail, clientInfo, IsPaymentDone) => {
 await afterPaymentActions.forEach(async (element) => {
    if(!!element.action &&  !!element.actionType && !element.triggerOnlyOnSuccess || (!!element.triggerOnlyOnSuccess && !!isPaymentSucces)){
      const API_Instance=!!element.is_API_Third_Party?THIRD_PARTY_API:API;
      switch(element.actionType){
        case "api":{
          let requestParams=!!element.requestParams && Object.keys(element.requestParams).length>0?element.requestParams:null;
          if(!!requestParams){
            requestParams=replaceTokenInObject(requestParams,userDetail,masterData,element.masterDataMapping,element.requestParamsDataType);
            requestParams = replaceTokenOfPDFAPIRequest(
              requestParams,
              get(userDetail,`lead.id`),
              clientInfo,
              IsPaymentDone || isPaymentSucces
            );
            let config = {
              method: !!element.type && !!REQUEST_TYPE[element.type]?element.type:REQUEST_TYPE.get,
              url: element.action,
              data : JSON.stringify(requestParams),
              mode:"no-cors",
              headers:{
                'Content-Type':'application/json',
                'Access-Control-Allow-Origin': '*',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
                withCredentials: true
              }
            };
            if(!!element.contentType){
              set(config.headers,'Content-Type',element.contentType)
            }
            if(!!config && !!config.method && !!config.url){

              return await API_Instance(config).then((response) => {
                console.log(response);
                return response;
              }, (error) => {
                console.log(error);
                return error;
              });
            }
          }
        }break;
        default:{
          return true;
        }
      }
    }
  });
}

export const callAPIButtonAction =  async (actionConfig, isPaymentSucces, masterData, userDetail, clientInfo, IsPaymentDone) => {
  if(!!actionConfig.action &&  !!actionConfig.actionType && !actionConfig.triggerOnlyOnSuccess || (!!actionConfig.triggerOnlyOnSuccess && !!isPaymentSucces)){
    const API_Instance=!!actionConfig.is_API_Third_Party?THIRD_PARTY_API:API;
    switch(actionConfig.actionType){
      case "api":
      case "hyperLinkThroughAPI":
      case "form":{
        let requestParams=!!actionConfig.requestParams && Object.keys(actionConfig.requestParams).length>0?actionConfig.requestParams:null;
        if(!!requestParams){
          forIn(requestParams,(requestValue,requestKey)=>{
            if(has(userDetail,requestValue)){
              set(requestParams,requestKey,!!get(userDetail,requestValue)?get(userDetail,requestValue):"");            
              if(actionConfig?.masterDataMapping && actionConfig.masterDataMapping[requestKey] != undefined){
                const collection = !isNil(masterData) && getMasterDataByKey(actionConfig.masterDataMapping[requestKey],masterData);
                if(checkIfArray(collection)){
                  const mappedMasterDataItem=find(collection,{id:Number(requestParams[requestKey].toString())});
                  const masterDataValueFieldMapping = get(actionConfig, `masterDataValueFieldMapping.${requestKey}`)
                  if(masterDataValueFieldMapping){
                    const masterValues = requestParams[requestKey];
                    if(checkIfArray(masterValues) && masterValues.length > 1){
                      let mappedMasterDataItem = reduce(collection, (result, item) => {
                        if(masterValues.includs(item.id)){
                          result.push(item);
                        }
                        return result
                      })
                      mappedMasterDataItem  = mappedMasterDataItem.map((ele) => {
                        return ele[masterDataValueFieldMapping[0]]
                      })
                      if(checkIfArray(masterDataValueFieldMapping)){
                        !isNil(mappedMasterDataItem[masterDataValueFieldMapping]) && set(requestParams,requestKey,mappedMasterDataItem);
                      }else{
                        !isNil(mappedMasterDataItem[masterDataValueFieldMapping]) && set(requestParams,requestKey,mappedMasterDataItem.toString());
                      }
                    }else{
                      if(checkIfArray(masterDataValueFieldMapping)){
                        !isNil(mappedMasterDataItem[masterDataValueFieldMapping]) && set(requestParams,requestKey,[mappedMasterDataItem[masterDataValueFieldMapping[0]]]);
                      }else{
                        !isNil(mappedMasterDataItem[masterDataValueFieldMapping]) && set(requestParams,requestKey,mappedMasterDataItem[masterDataValueFieldMapping]);
                      }
                    }
                  }else{
                    !!mappedMasterDataItem && !isNil(mappedMasterDataItem.name) && set(requestParams,requestKey,mappedMasterDataItem.name);
                  }
              }
            }
            }
          });
          requestParams = replaceTokenOfPDFAPIRequest(
            requestParams,
            get(userDetail,`lead.id`),
            clientInfo,
            IsPaymentDone
          )
          //actionConfig.action=`${actionConfig.action}1`;
          if(actionConfig.actionType==="api"){
            if(!actionConfig.type || actionConfig.type==="get"){
              return await API_Instance.get(actionConfig.action,{params:requestParams}).then((response) => {
                console.log(response);
                return response;
              }, (error) => {
                console.log(error);
                return error;
              });
            }else if(actionConfig.type==="post"){
              return await API_Instance.post(actionConfig.action,requestParams).then((response) => {
                console.log(response);
                return response;
              }, (error) => {
                console.log(error);
                return error;
              });
            }
          }else if(!!requestParams && Object.keys(requestParams).length>0 && !!actionConfig.action && actionConfig.actionType==="form"){
            generateFormAndSubmit({
              id: "custom-form",
              type:actionConfig.type,
              url: actionConfig.action,
              formData: requestParams,
            });
          } else if(actionConfig.actionType === "hyperLinkThroughAPI"){
            if(!actionConfig.type || actionConfig.type==="get"){
              return await API_Instance.get(actionConfig.action,{params:requestParams}).then((response) => {
                const {status} = response || {};
                if(status===201 || status===200){
                  const url = get(response, `data.${actionConfig.URLApiKey}`);
                  url && createAnchorTag(url, "_blank", "", true)
                  return false;
                }else{
                  console.log("URL not generated.");
                  return true;
                }
              }, (error) => {
                console.log("URL not generated.");
                return true;
              });
            }else if(actionConfig.type==="post"){
              return await API_Instance.post(actionConfig.action,requestParams).then((response) => {
                const {status} = response || {};
                if(status===201 || status===200){
                  const url = get(response, `data.${actionConfig.URLApiKey}`);
                  url && createAnchorTag(url, "_blank", "", true)
                  return false;
                }else{
                  console.log("URL not generated.");
                  return true;
                }
              }, (error) => {
                console.log("URL not generated.");
                return true;
              });
            }
          }         
        }
      }break;
      case "hyperlink":{
        let requestParams=!!actionConfig.requestParams && Object.keys(actionConfig.requestParams).length>0?actionConfig.requestParams:null;
        if(!!requestParams){
          forIn(requestParams,(requestValue,requestKey)=>{
            if(has(userDetail,requestValue)){
              set(requestParams,requestKey,!!get(userDetail,requestValue)?get(userDetail,requestValue):"");            
              if(actionConfig?.masterDataMapping && actionConfig.masterDataMapping[requestKey] != undefined){
                const collection = !isNil(masterData) && getMasterDataByKey(actionConfig.masterDataMapping[requestKey],masterData);
                if(checkIfArray(collection)){
                  const mappedMasterDataItem=find(collection,{id:Number(requestParams[requestKey].toString())});
                  !!mappedMasterDataItem && !isNil(mappedMasterDataItem.name) && set(requestParams,requestKey,mappedMasterDataItem.name);
                }
              }
            }
          });
        }
        let url = actionConfig.action && actionConfig.action; 
        if(url){
          if(actionConfig.type && actionConfig.type === "multipleParamsShowInURL"){
            let newUrl = new URL(url);
            for (const [key, value] of Object.entries(requestParams)) {
              newUrl.searchParams.set(key, value);
            }
            createAnchorTag(newUrl.href, "_blank", "", true)
          }else{
            const encodedBase64 = checkIfObject(requestParams) && btoa(JSON.stringify(requestParams));
            url = url + encodedBase64;
            createAnchorTag(url, "_blank", "", true)
          }
          
        }else{
          console.error("Url is not provided in the formConfig");
        }
        
      }break;
      default:{
        return true;
      }
    }
  }
 }

 export const generateTempAnchorTagAndClick=(params)=>{
    // Create anchor element. 
    var a = document.createElement('a');  
            
    // Set the href property. 
    a.href = params.href;  
    // Set the href property. 
    a.target = !!params && !!params.target?params.target:"_blank";  
      
    // Append the anchor element to the body. 
    document.body.appendChild(a);  
    setTimeout(function(aTag){ aTag.click();aTag.remove(); }, 500, a);
 }

 /**
 * @author Krushna Sharma
 * @creationDate 03 Apr 2021
 * @description Checks if the passed parameter is not null, is Array and has length > 0
 * @param {Array} arrayParam Array parameter to be checked
 */
 export const checkIfArray = (arrayParam) => {
  return !!(arrayParam && isArray(arrayParam) && arrayParam.length > 0 && !isNil(arrayParam[0]));
 }

 /**
 * @author Krushna Sharma
 * @creationDate 03 Apr 2021
 * @description Removes those slot from the slots list which has expired. 
 * @param {Array} slotsList array of slots
 */
  export const removeExpiredSlot = (slotsList,selectedSlotId=null) => {
    let validSlots = []
     if(checkIfArray(slotsList)){
       let today = moment();
       validSlots=slotsList.filter(slots=>{
         return (today.isBefore(moment(ConvertToLocalUsingMoment(slots.expiryDate,'YYYY-MM-DDTHH:mm:ss.SSSS'))) && (!!slots.availableSlotCount) && (isNil(slots.isActive) || !!slots.isActive)) || (!!selectedSlotId && slots.id===selectedSlotId)
       })
     }
     return validSlots
  }
  
  /**
  * @author Pradip Udavant
  * @creationDate 09 Apr 2021
  * @description Check slot is expired
  * @param slot object
  */
  export const isSlotExpired = (slot) => {
     if(!isNil(slot)){
       let today = moment();
       return !today.isBefore(moment(ConvertToLocalUsingMoment(slot.expiryDate,'YYYY-MM-DDTHH:mm:ss.SSSS')));
     }
     return true;
  }

  
  export const getReceiptURLByReceiptNumber=(receiptNumber,templatePdfs)=>{   
    let url="";    
    receiptNumber=!!receiptNumber ? receiptNumber.replace(/[,\/!@#$%^&*'\\;():|[\]+ ]/g,'_') : receiptNumber;//replace all special char to _
    if(!!receiptNumber &&  !!templatePdfs && (!!get(templatePdfs,`Payment_Receipt_${receiptNumber}`) || !!get(templatePdfs,`${receiptNumber}`))){
      url=getMediaLiveURL(templatePdfs[`Payment_Receipt_${receiptNumber}`] || templatePdfs[`${receiptNumber}`]);
   }    
    return !!url?url:undefined;
  }
  export const checkAndGetDefaultPromocode = (
    userDetail = null,
    masterData = null,
    feesType = null
  ) => {
    if (isNil(userDetail) || isNil(masterData) || isNil(feesType)) {
      return null;
    }
    const indexedKeyValueAttributes =
      userDetail?.metaData?.indexedKeyValueAttributes;
    if (
      checkIfArray(indexedKeyValueAttributes)
    ) {
      const promoCodeAppliedOn = DEFAULT_PROMO_CODE_MASTER_KEY[feesType];
      const masterKeysCollection = !isNil(masterData) && getMasterDataByKey(`MasterKeys`,masterData);
      let promoCodeAppliedOnMasterKeyObj = checkIfArray(masterKeysCollection) 
          ? find(masterKeysCollection, { name: promoCodeAppliedOn })
          : null;
  
      const indexedMetaData =
        !isNil(promoCodeAppliedOnMasterKeyObj) &&
        !!get(promoCodeAppliedOnMasterKeyObj, `id`)
          ? indexedKeyValueAttributes.find(
              (ele) => ele.keyId === promoCodeAppliedOnMasterKeyObj.id
            )
          : null;
      if (!isNil(indexedMetaData) && !!indexedMetaData.textValue) {
        return indexedMetaData?.textValue;
      }
    }
    return null;
  };

  export const checkIfObject = (obj) => {
    return !!(obj && typeof obj === "object" && Object.keys(obj) && Object.keys(obj).length)
  }

/**
 * @author Arnab Das
 * @creationDate 24 Feb 2022
 * @description Checks if the passed values are truly equal
 * @param {val1} any Array or Object or String or Number
 * @param {val2} any Array or Object or String or Number
 */
  export const checkIfEquals = (val1, val2) => {
    if(Array.isArray(val1) && Array.isArray(val2)) return isEqual(val1.sort(), val2.sort())
    else return isEqual(val1, val2)
  }

  export const isJsonString = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  export const metaDataUpdate = (masterData, userDetail, metaDataType, masterKey, metaDataValue, newMetaRequestObject) => {
    const metaDataObj = get(userDetail,`metaData.${metaDataType}`) || [];
    const masterKeysCollection = !isNil(masterData) && getMasterDataByKey(`MasterKeys`,masterData);
    const masterKeyObj=checkIfArray(masterKeysCollection) ? find(masterKeysCollection,item=>{return item.name===masterKey;}):null;
    if(Array.isArray(metaDataObj)){
      let keyMetaData=find(metaDataObj,{keyId:masterKeyObj.id});
      if(metaDataType === META_DATA_TYPE.INDEX_META_TYPE) {
        let valueType = checkMasterKeyValueType(masterKeyObj.type)
        if(isNil(keyMetaData)){
          keyMetaData = {
            keyId: masterKeyObj.id,
            leadId: userDetail.lead.id,
            [valueType]: metaDataValue,
            id: 0
          }
          metaDataObj.push(keyMetaData)
          set(userDetail,`metaData.${metaDataType}`,metaDataObj);
        }
        else {
          // edit value of indexedKeyValueAttributes
          
          let keyObj = metaDataObj.findIndex(item => item.keyId === masterKeyObj.id)
          metaDataObj[keyObj][valueType] = metaDataValue
          if(newMetaRequestObject) {
            newMetaRequestObject[META_DATA_TYPE.INDEX_META_TYPE][keyObj][valueType] = metaDataValue
            return newMetaRequestObject
          }
        }
      }
      else if (metaDataType === META_DATA_TYPE.NON_INDEX_META_TYPE) {
        if(isNil(keyMetaData)) {
          keyMetaData = {
            keyId: masterKeyObj.id,
            leadId: userDetail.lead.id,
            value: metaDataValue,
            id: 0
          }
          metaDataObj.push(keyMetaData)
          set(userDetail,`metaData.${metaDataType}`,metaDataObj);
        }
        else {
          // edit value of nonIndexedKeyValueAttributes
          let keyObj = metaDataObj.findIndex(item => item.keyId === masterKeyObj.id)
          let keyValueObj = isJsonString(metaDataObj[keyObj].value) && JSON.parse(metaDataObj[keyObj].value)
          keyValueObj && Object.assign(keyValueObj, {masterKey: metaDataValue})
          metaDataObj[keyObj].value = JSON.stringify(keyValueObj)
        }
      }
    }

  }

  export const checkMasterKeyValueType = (type) => {
    switch (type) {
      case MASTER_KEYS.TYPE.DOUBLE: return META_DATA_INDEXED_VALUE_TYPE.DOUBLE //"doubleValue"
      case MASTER_KEYS.TYPE.INTEGER: return META_DATA_INDEXED_VALUE_TYPE.INTEGER //"integerValue"
      case MASTER_KEYS.TYPE.BOOLEAN: return META_DATA_INDEXED_VALUE_TYPE.BOOLEAN //"boolValue"
      case MASTER_KEYS.TYPE.TEXT: return META_DATA_INDEXED_VALUE_TYPE.STRING //"textValue"
      case MASTER_KEYS.TYPE.DATE: return META_DATA_INDEXED_VALUE_TYPE.DATE //"dateValue"
      default: 
    }
  }

  export const checkIfMasterKeyPresent = (masterData, masterKeyName) => {
    const masterKeysCollection = !isNil(masterData) && getMasterDataByKey(`MasterKeys`,masterData);
    return checkIfArray(masterKeysCollection) ? find(masterKeysCollection,item=>{return item.name===masterKeyName}):null;
  }
/**
 * 
 * @param {Array} arr 
 * @returns true/false - true if given array will in 0,1,2,3,4 and false if 0,3 
 */
  export const isArrayValueInSequence=(arr)=>{
    if(!!arr && Array.isArray(arr) && arr.length>0)
    {
      arr.sort();
      return !arr.some((value,index,collection)=>{ return index===0 && value>0 || index>0 && value-collection[index-1]!==1 })
    }
    return false;
  }


  export const getStepWiseMandatoryFields=(formConfig,clientInfo,masterData,formData)=>{
    let output = {};
    const leadStatuses = !isNil(masterData) && getMasterDataByKey(`LeadStatuses`,masterData);
    formConfig && clientInfo && masterData && forEach(get(formConfig, "steps"), function (step,stepIndex) {
        const statusMappingConfig=find(clientInfo.LeadstatusDetails.applicationFormStatusMapping,{key:step.lead_status_key});
        const mappedStatusObject= !!statusMappingConfig?.LeadStatusTitle && !!masterData && checkIfArray(leadStatuses) && find(leadStatuses,{name:statusMappingConfig.LeadStatusTitle});
      const mappedStatusId= !!mappedStatusObject && mappedStatusObject?.id
      let mandatoryFields=[];
      forEach(get(step, "config.panels"), function (panel) {
        let isFormConfigChanged = false;
        let conditionallyRemovedFields = {};
        let {required} = panel;
        required=uniq(required);
        if(required && Array.isArray(required) && required.length>0){
            mandatoryFields=reduce(required,(result, item)=>{
              if(get(panel,`fields[${item}]`)){
                /*console.log(`getStepWiseMandatoryFields - item`,item);
                let formConfigChangedOutput = updateDependenciesRefComponents(
                  get(panel,`fields[${item}]`),
                  formData && get(formData,item),
                  get(step, "config")
                );
                isFormConfigChanged =
                  !isNil(formConfigChangedOutput) &&
                  !isNil(get(formConfigChangedOutput, "isFormConfigChanged"))
                    ? get(formConfigChangedOutput, "isFormConfigChanged")
                    : isFormConfigChanged;
                conditionallyRemovedFields =
                  !isNil(formConfigChangedOutput) &&
                  !isNil(get(formConfigChangedOutput, "conditionallyRemovedFields"))
                    ? get(formConfigChangedOutput, "conditionallyRemovedFields")
                    : conditionallyRemovedFields;*/
                /*if(!get(conditionallyRemovedFields,item) && get(panel,`fields[${item}].visible`)){
                  result.push({key:item,title:get(panel,`fields[${item}].title`)});
                }*/
                if(get(panel,`fields[${item}].visible`)){
                  result.push({key:item,title:get(panel,`fields[${item}].title`)});
                }
              }
              return result;
            },mandatoryFields);        
        }
      });
      !!mandatoryFields && Array.isArray(mandatoryFields) && mandatoryFields.length>0 && set(output,mappedStatusId,{mandatoryFields,stepIndex,stepHeading:get(step,`config.heading`)});
    });
    return !!output && Object.keys(output).length>0 ? output : null;
  }

  export const checkMandatorySteps = (config) => { // checks all mandatory fields in config
    return reduce(config.steps,function(stepResult,stepData){
      let selectConditionlRefFieldsArr = [];
      let stepItems = reduce(stepData.config.panels,function(panelResult, panelData){
        let hideRequiredPanelsFieldArr = [];
        const panelDataRequired = panelData.required;
        let panelDataFields = checkIfObject(panelData.fields) && Object.keys(panelData.fields);
        if(checkIfArray(panelDataFields)){
          reduce(panelDataFields,function(requiredResult,fieldKey){
            const selectRefFields = get(panelData,`fields.${fieldKey}.ref.showFields`);
            const conditionlRefFieldsArr = get(panelData,`fields.${fieldKey}.ref.conditional`);
            const conditionlRefHidePanels = get(panelData,`fields.${fieldKey}.ref.hidePanels`);
            const conditionlRefShowPanels = get(panelData,`fields.${fieldKey}.ref.showPanels`);
            let selectConditionlRefFields = [];
            checkIfArray(conditionlRefFieldsArr) && conditionlRefFieldsArr.forEach(ele => {
              if(checkIfArray(ele.showFields)){
                selectConditionlRefFields = [...selectConditionlRefFields, ...ele.showFields]
              }
              if(checkIfArray(ele.showPanels)){
                hideRequiredPanelsFieldArr = [...hideRequiredPanelsFieldArr, ...ele.showPanels]
              }
            })
            if(checkIfArray(selectConditionlRefFields)){
              selectConditionlRefFieldsArr = [...selectConditionlRefFieldsArr,...selectConditionlRefFields];
            }
            if(checkIfArray(selectRefFields)){
              selectConditionlRefFieldsArr = [...selectConditionlRefFieldsArr,...selectRefFields];
            }
            if(checkIfArray(conditionlRefShowPanels)){
              hideRequiredPanelsFieldArr = [...hideRequiredPanelsFieldArr, ...conditionlRefShowPanels]
            }
            if(checkIfArray(conditionlRefHidePanels)){
              hideRequiredPanelsFieldArr = [...hideRequiredPanelsFieldArr, ...conditionlRefHidePanels]
            }
            if(checkIfArray(panelDataRequired) && !!panelDataRequired.includes(fieldKey) && get(panelData,`fields.${fieldKey}.type`) !== FORM_INPUT_UI.BOOLEAN && get(panelData,`fields.${fieldKey}.visible`) && (get(panelData,`fields.${fieldKey}.conditionShow`) === undefined ||
              get(panelData,`fields.${fieldKey}.conditionShow`) === true)
              ){
                panelResult.push(fieldKey)
              } 
            return requiredResult;
          },[])
        }
        if(checkIfArray(hideRequiredPanelsFieldArr)){
          hideRequiredPanelsFieldArr.forEach(ele => {
            const hideElePanelsField = stepData.config.panels && stepData.config.panels[ele] && stepData.config.panels[ele].required;
            if(checkIfArray(hideElePanelsField)){
              selectConditionlRefFieldsArr = [...selectConditionlRefFieldsArr, ...hideElePanelsField]
            }
          })
        }
        return panelResult; 
      },[]);
      if(checkIfArray(selectConditionlRefFieldsArr)){
        stepItems = stepItems.filter(ele => !selectConditionlRefFieldsArr.includes(ele))
      }
      set(stepResult,`${stepData.id}`,stepItems)
      return stepResult; 
    },{});
  }
  
/**
 * @author Chintan Patel
 * @creationDate 29 Sep 2022
 * @description Replace special charater with replaceValue
 * @param {stringValue} String to be replaced
 * @param {replaceValue} any Array or Object or String or Number
 */
  export const replaceSpecialCharacter = (stringValue, replaceValue="_") => {
    return typeof(stringValue) === 'string' ? stringValue.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, replaceValue) : stringValue;
  }
  export function getPaidEntitiesIds(userDetail, clientInfo){
    const { paymentDetails } = userDetail;
    let payment_txn_success_status =
      clientInfo &&
      !isNil(get(clientInfo, "paymentDetails.payment_success_status")) &&
      Array.isArray(get(clientInfo, "paymentDetails.payment_success_status")) &&
      get(clientInfo, "paymentDetails.payment_success_status").length
        ? get(clientInfo, "paymentDetails.payment_success_status")
        : PAYMENT_SUCCESS_STATUS;

    return (
      paymentDetails &&
      map(
        filter(paymentDetails, item => {
          return (
            (isNil(get(item, "paymentDetailsModel.feesType")) ||
              isEmpty(get(item, "paymentDetailsModel.feesType")) ||
              get(item, "paymentDetailsModel.feesType") ===
                FEES_TYPE.APPLICATION_FORM_FEES) &&
            payment_txn_success_status.includes(
              get(item, "paymentDetailsModel.transactionStatus")
            )
          );
        }),
        item => {
          set(
            get(item, "paymentDetailsModel"),
            "entityId",
            get(item, "enrolledLeadModel.entityId")
          );
          /*UKC code - COMMENTED FOR FUTHER USE  */
          !isNil(get(item, "enrolledLeadModel.amount")) && set(
            get(item, "paymentDetailsModel"),
            "amount",
            get(item, "enrolledLeadModel.amount")
          );
          return get(item, "paymentDetailsModel");
        }
      )
    );
}

export function getEnrolledLeadModel(paymentDetails){
  let returnVal = [];
  if(checkIfArray(paymentDetails)){
    paymentDetails.forEach(ele => {
      if(ele?.enrolledLeadModel){
        returnVal.push(ele.enrolledLeadModel);
      } 
    })
  }
  return returnVal;
}

export function getFieldFromConfig(formConfig, field){
  const { steps } = formConfig || {};
  let result = {};
  let flag = false;
  if(checkIfArray(steps)){
    steps.every(step => {
      const panels = get(step, "config.panels") || {};
      if(checkIfObject(panels)){
        const panelValue = Object.values(panels);
        if(checkIfArray(panelValue)){
          panelValue.every(panel => {
            const { fields } = panel || {};
            const fieldKeys = Object.keys(fields);
            fieldKeys.every(key => {
              if(key === field){
                result = fields[key];
                flag = true;
                return false;
              }
              return true;
            })
            if(flag) return false;
            else return true;
          })
        }
      }
      if(flag) return false;
      else return true;
      
    })
  }
  return result;
}
export const isMasterDataFrom_GZIP_OR_JSON=(clientConfig)=>{
  if(clientConfig){    
    if(!!clientConfig[STORAGE_KEY.IS_MASTER_DATA_FROM_GZIP_FEATURE_ACTIVE] && !!clientConfig[STORAGE_KEY.REQUEST_MASTERDATA_FROM_GZIP]){
      return true;
    }else if(!!clientConfig[STORAGE_KEY.IS_MASTER_DATA_FROM_JSON_FEATURE_ACTIVE] && !!clientConfig[STORAGE_KEY.REQUEST_MASTERDATA_FROM_JSON]){
      return true;
    }
  }
  return false;
}

export const createAnchorTag = (url, target = "", className = "", isClicked) => {
  if (url) {
    let updatedUrl = url;
    if(isClicked){
      updatedUrl = (url.startsWith("http://") || url.startsWith("https://")) 
      ? url 
      : `https://${url}`;
    }
    const anchorTag = document.createElement("A");
    anchorTag.setAttribute("href", updatedUrl);
    anchorTag.setAttribute("class", className)
    anchorTag.setAttribute("target", target);
    document.body.appendChild(anchorTag);
    isClicked && anchorTag.click();
  }
}
export const downloadAs = (url, name) => {
  Axios.get(url, {
    headers: {
      "Content-Type": "application/octet-stream",
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0'
    },
    responseType: "blob"
  })
    .then(response => {
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(response.data);
      a.href = url;
      a.download = name;
      a.click();
    })
    .catch(err => {
      console.log("error", err);
    });
};

//replace with stars
export function replaceEmailWithStars(email) {
  var text = email ? email.split("@") : [];
  if (text.length == 2) {
    if (text[0].length == 2) {
      //ex. hr@company.com => **@company.com
      return text[0].replace(/./g, "*") + "@" + text[1];
    }
    let lastIndex = text[0].length - 1;
    let middleString = text[0].slice(1, lastIndex); // string between first and last letter
    let stars = middleString.replace(/./g, "*"); //replce characters with *;
    return (
      text[0].charAt(0) + stars + text[0].charAt(lastIndex) + "@" + text[1]
    );
  }
  return email;
}
// replace phnNumber with stars---- replace all digits to star except last 4 digits
export function replaceMobileWithStars(phnNumber, isMobile2Type) {
  phnNumber = phnNumber ? phnNumber.toString() : "";
  let len = phnNumber.length;
  let numberVisibleLen = isMobile2Type ? 2 : 4
  let preDigits = phnNumber.slice(0, len - 4); //get all digits other than last 4 digits
  let stars = preDigits.replace(/./g, "*");
  return stars + phnNumber.slice(len - numberVisibleLen, len);
}

export const getUnpaidCourseCurrencyList = (formData, masterData, userDetail, clientInfo, selectedCurrency=false, feesType=1, selectedCourseIds=false) => {
  let returnVal = [], unPaidPaymentsIds, allPaidPaymentDetails;
  if(checkIfArray(masterData?.currencies)){
    if(!selectedCourseIds){
      selectedCourseIds = getSelectedCourseIds(formData, masterData);
    }
    if(feesType === 2){
      allPaidPaymentDetails = getCourseFeesPaidEnttiesIds(userDetail, clientInfo);
      unPaidPaymentsIds = checkIfArray(allPaidPaymentDetails) ? selectedCourseIds.filter(ele => !allPaidPaymentDetails.some(entry => entry.entityId == ele)) : [...selectedCourseIds];
    }else{
      allPaidPaymentDetails = getPaidEntitiesIds(userDetail, clientInfo);
      unPaidPaymentsIds = checkIfArray(allPaidPaymentDetails) ? selectedCourseIds.filter(ele => !allPaidPaymentDetails.some(entry => entry.entityId == ele)) : [...selectedCourseIds];
    }
    const pricingCriterion2 = masterData.pricingCriterion2;
    const pricingCriterion2Val = (checkIfArray(pricingCriterion2) && pricingCriterion2[0].dataKey && formData[pricingCriterion2[0].dataKey] && formData[pricingCriterion2[0].dataKey].toString()) || null;
    const pricingListCollection = !isNil(masterData) && getMasterDataByKey(`PricingList`,masterData);
    const unPaidSelectedPricingList = pricingListCollection.filter(ele => unPaidPaymentsIds.includes(ele.entityId) && ele.criterionValue == pricingCriterion2Val);
    if(!selectedCurrency){
      
    const currenciesCollection = !isNil(masterData) && getMasterDataByKey(`currencies`,masterData);
      returnVal = unPaidSelectedPricingList.map(item => {
        if(item.currency){
          const currencyObj =checkIfArray(currenciesCollection) && currenciesCollection.find(ele => ele.ISOCode === item.currency);
          return currencyObj;
        }else{
          return DEFAULT_CURRENCY;
        }
      })
      returnVal = uniqBy(returnVal, "ISOCode");
    }else{
      if(checkIfObject(selectedCurrency) && !Array.isArray(selectedCurrency)){
        returnVal = unPaidSelectedPricingList.filter(item => !item.currency);
      }else{
        selectedCurrency = selectedCurrency && selectedCurrency.toString();
        if(selectedCurrency && selectedCurrency !== DEFAULT_CURRENCY.ISOCode){
          //used filter instead of find method as there could be multiple courses
          returnVal = unPaidSelectedPricingList.filter(item => selectedCurrency === item.currency)
        }else{
          returnVal = unPaidSelectedPricingList.filter(item => !item.currency);
        }
      }
    }
  }
  return returnVal;
}

export const getTotalDiscountedAmountToPay=(amount, promoCodeDetails)=> {
  if (parseFloat(amount) <= 0) {
    return 0;
  }
  if(checkIfObject(promoCodeDetails)) {
    switch (get(promoCodeDetails, "discountType")) {
      case PROMOCODE_DISCOUNT_TYPE.AMOUNT:
        amount =
          parseFloat(amount) -
          parseFloat(get(promoCodeDetails, "discount"));
        break;
      case PROMOCODE_DISCOUNT_TYPE.PERCENTAGE:
        amount = (
          parseFloat(amount) -
          (parseFloat(amount) *
            parseFloat(get(promoCodeDetails, "discount"))) /
            100
        ).toFixed(2);
        break;
      default: {
      }
    }
  }
  return amount < 0 ? 0 : amount;
}

export const setCurrencyListAsPerUnPaidCourses = (selectedCourseToPay, masterData, formData) => {
  let { pricingCriterion2 } = masterData || {};
  const currenciesCollection = !isNil(masterData) && getMasterDataByKey(`currencies`,masterData);
  const pricingListCollection = !isNil(masterData) && getMasterDataByKey(`PricingList`,masterData);
  const pricingCriterion2Val = (checkIfArray(pricingCriterion2) && pricingCriterion2[0].dataKey && formData[pricingCriterion2[0].dataKey] && formData[pricingCriterion2[0].dataKey].toString()) || null;
  const unPaidSelectedPricingList = pricingListCollection.filter(ele => selectedCourseToPay.includes(ele.entityId) && ele.criterionValue == pricingCriterion2Val);
  let updatedCurrencyList = unPaidSelectedPricingList.map(item => {
    if(item.currency){
      const currencyObj = checkIfArray(currenciesCollection) && currenciesCollection.find(ele => ele.ISOCode === item.currency);
      return currencyObj;
    }else{
      return DEFAULT_CURRENCY;
    }
  });
  return updatedCurrencyList;
}

export const getCourseFeesPaidEnttiesIds = (userDetail, clientInfo) => {
  let payment_txn_success_status =
      clientInfo &&
      !isNil(get(clientInfo, "paymentDetails.payment_success_status")) &&
      Array.isArray(get(clientInfo, "paymentDetails.payment_success_status")) &&
      get(clientInfo, "paymentDetails.payment_success_status").length
        ? get(clientInfo, "paymentDetails.payment_success_status")
        : PAYMENT_SUCCESS_STATUS;
  return (
    userDetail &&
    userDetail.paymentDetails &&
    map(
      filter(userDetail.paymentDetails, item => {
        return (
          !isNil(
            get(
              item,
              "paymentDetailsModel." + HARD_CODED_FIELD_KEYS.FEES_TYPE
            )
          ) &&
          get(
            item,
            "paymentDetailsModel." + HARD_CODED_FIELD_KEYS.FEES_TYPE
          ) === FEES_TYPE.COURSE_FEES &&
          payment_txn_success_status.includes(
            get(item, "paymentDetailsModel.transactionStatus")
          )
        );
      }),
      item => {
        set(
          get(item, "paymentDetailsModel"),
          "entityId",
          get(item, "enrolledLeadModel.entityId")
        );   
        /*UKC code - COMMENTED FOR FUTHER USE  */       
        !isNil(get(item, "enrolledLeadModel.amount")) && 
        set(get(item, "paymentDetailsModel"),
          "amount",
          get(item, "enrolledLeadModel.amount")
        );
        return get(item, "paymentDetailsModel");
      }
    )
  );
}
export function sortListByDate(records, key, sortBy) {
  if (!!records && records.length > 0) {
    records.sort(function (a, b) {
      var key1 = new Date(a[key]);
      var key2 = new Date(b[key]);
      if (sortBy == "asc") {
        if (key1 < key2) {
          return -1;
        } else if (key1 == key2) {
          return 0;
        } else {
          return 1;
        }
      } else if (sortBy == "desc") {
        if (key1 > key2) {
          return -1;
        } else if (key1 == key2) {
          return 0;
        } else {
          return 1;
        }
      }
    });
  }
  return records;
}
/**
 * 
 * @param {*} pricingItems 
 * @param {*} amountFieldKey 
 * @param {*} comboDiscountConfiguration 
 * @returns pricingItems by added new property as Combo
 */
export const applyComboDiscounts=(pricingItems, amountFieldKey, comboDiscountConfiguration)=>
{
  if(!checkIfArray(pricingItems) && pricingItems.length>1){
    return null;
  }
  if(!checkIfObject(comboDiscountConfiguration) || !comboDiscountConfiguration.isActive || !checkIfObject(get(comboDiscountConfiguration,`comboDiscounts`))){
    return null;
  }
  const {comboDiscounts,comboDiscountsType} = comboDiscountConfiguration;
  let comboDiscountsKeys = keys(comboDiscounts);
  comboDiscountsKeys = values(comboDiscountsKeys);
  let discount = 0;
  if(parseFloat(comboDiscountsKeys[comboDiscountsKeys.length])<pricingItems.length){
    discount = parseFloat(comboDiscountsKeys[comboDiscountsKeys.length])
  }else{
    discount = find(comboDiscountsKeys,(val)=>{
      const intVal = parseFloat(val);
      return intVal===pricingItems.length || intVal>pricingItems.length;
    });
  }
  const COMBO_DISCOUNT_TYPE = {
    PERCENTAGE:"percentage",
    AMOUNT:"amount"
  }
  if(!!comboDiscounts[discount]){
    pricingItems = map(pricingItems,item=>{      
      const amount = parseFloat(item[amountFieldKey]);
      const discountValue = parseFloat(comboDiscounts[discount]);
      let discountAmount = 0;
      if(comboDiscountsType === COMBO_DISCOUNT_TYPE.PERCENTAGE){
        discountAmount = amount - (amount*discountValue)/100;
        discountAmount = parseFloat(discountAmount).toFixed(2);
      }
      if(comboDiscountsType === COMBO_DISCOUNT_TYPE.AMOUNT){
        discountAmount = amount - discountValue;
      }
      if(!!discountAmount){
        set(item,`combo${amountFieldKey}`,parseFloat(discountAmount));
      }
      return item;
    });
    return parseFloat(parseFloat(sumBy(pricingItems,`combo${amountFieldKey}`)).toFixed(2));
  }
  return null;
}

/**
 * 
 * @param {*} excludeFields 
 * @param {*} addExcludeFieldsByValues 
 * @param {*} initialFormData 
 * @returns exclude fields according to intial form data
 */
export const updateExcludeByFieldsValue=(excludeFields=[], addExcludeFieldsByValues={}, initialFormData={})=>{
  if(checkIfObject(addExcludeFieldsByValues) && checkIfObject(initialFormData)){
    let newExcludeFields = checkIfArray(excludeFields) ? [...excludeFields] : [];
    for(const fieldKey in addExcludeFieldsByValues){
      let fieldValue = get(initialFormData, fieldKey);
      fieldValue = checkIfArray(fieldValue) ? fieldValue : fieldValue ? [fieldValue] : [];
      let skipValues = get(addExcludeFieldsByValues, fieldKey);
      skipValues = checkIfArray(skipValues) ? skipValues : skipValues ? [skipValues] : [];
      if(checkIfArray(fieldValue) && checkIfArray(skipValues) && intersection(fieldValue,skipValues).length){
        newExcludeFields.push(fieldKey);
      }else if(excludeFields.includes(fieldKey)){
        newExcludeFields = remove(newExcludeFields, (n) => n !== fieldKey)
      }
    }
    return newExcludeFields
  }
  return excludeFields;
}

/**
 * 
 * @param {*} value1 
 * @param {*} value2 
 * @returns checks (true or false) if value2 is present in value2
 */
export const checkIfValuePresent = (array1 , array2) => {
    if(!array1 || !array2) return null;
    array1 = checkIfArray(array1) ? array1 : array1 ? [array1 ] : null;
    array2 = checkIfArray(array2) ? array2 : array2 ? [array2] : null;
    return !!array1 && !!array2 && intersection(array1,array2).length;
}
/**
 * 
 * @param {*} ref 
 * @param {*} formData 
 * @param {*} canDisplay 
 * @returns checks if we need hide or show component based on formData
 */
export const checkHideAndShowConfig = (ref, formData, canDisplay = false,)=> {
  if(checkIfObject(ref)){
    const {showFields, hideFields} = ref || {};
    if(checkIfObject(showFields)){
      for(const fieldKey in showFields){
        canDisplay = checkIfValuePresent(get(formData, fieldKey), get(showFields, fieldKey))
      }
    }
    if(checkIfObject(hideFields)){
      for(const fieldKey in hideFields){
        canDisplay = !checkIfValuePresent(get(formData, fieldKey), get(hideFields, fieldKey))
      }
    }
  }
  return canDisplay;
}

export const getAllFields = (stepConfig)=> {
  const panels = get(stepConfig,`config.panels`);
  const fields = checkIfObject(panels) && Object.keys(panels).reduce((newFields, panel)=>{
    const field = get(panels,`${panel}.fields`);
    const fieldArray = checkIfObject(field) && Object.keys(field);
    fieldArray && newFields.push(...fieldArray);
    return newFields;
  },[]);
  return fields;
}


export const isPreferenceSequencesSequential = (
  preferenceSequences,
  enteredValue,
  incorrectPreferenceSequence = {}
) => {
  const sequentialSingleDigitArr = Array.from(
    { length: 9 },
    (_, index) => index + 1
  );
  const sortedArray = enteredValue ? [...new Set(preferenceSequences.sort((a, b) => a - b))] : preferenceSequences.sort((a, b) => a - b);

  for (let i = 0; i <= sortedArray.length; i++) {
    const sequence = i + 1;
    if(!enteredValue && sortedArray[i] && sortedArray[i] === sortedArray[sequence]){
      incorrectPreferenceSequence.current = sortedArray[i];
      incorrectPreferenceSequence.isDuplicate = true;
      return false;
    } else if (sortedArray[i] !== sequence) {
      const isSingleDigitArr = sequentialSingleDigitArr.every((value) =>
        preferenceSequences.includes(value)
      );
      if(enteredValue && isSingleDigitArr){
        if(enteredValue.toString().length !== sequence.toString().length){
           if(enteredValue.toString()[0] !== sequence.toString()[0]){
            incorrectPreferenceSequence.current = sequence;
            return false;
           }else{
            return true;
           }
        }else if(sequence !== enteredValue){
          incorrectPreferenceSequence.current = sequence;
          return false;
        }else{
          return true;
        }
      } else if (
        enteredValue &&
        sequence !== enteredValue
      ) {
        incorrectPreferenceSequence.current = sequence;
        return false;
      } else if (enteredValue) {
        return true;
      } else if (i !== sortedArray.length) {
        incorrectPreferenceSequence.current = sequence;
        return false;
      }
    }
  }

  return true;
};

export const validateDateRange = (newEntry, gridData, config, dateFormat = FORM_INPUT_VALUE_FORMAT.date.toUpperCase() ) => {
  const { outsideDateRange} = config || {};
  if(checkIfArray(gridData) && checkIfObject(outsideDateRange)){
    const {id} = newEntry || {};
    const {fromDateFieldKey, toDateFieldKey} = outsideDateRange;
    if(newEntry && toDateFieldKey && fromDateFieldKey && newEntry[fromDateFieldKey] && newEntry[toDateFieldKey]){
      const currentFrom = moment(newEntry[fromDateFieldKey], dateFormat);
      const currentTo = moment(newEntry[toDateFieldKey], dateFormat);
      if(currentFrom && currentTo){
        for(let i = 0; i < gridData.length; i++){
          const data = gridData[i];
          if(data.id == id) continue;
          const previousFrom = moment(data[fromDateFieldKey], dateFormat);
          const previousTo = moment(data[toDateFieldKey], dateFormat);
          const isInBetween = moment(previousFrom).isBetween(currentFrom, currentTo) || moment(previousTo).isBetween(currentFrom, currentTo) || moment(currentFrom).isBetween(previousFrom, previousTo) || moment(currentTo).isBetween(previousFrom, previousTo) || (moment(currentTo).isSame(previousTo) || moment(currentFrom).isSame(previousFrom) || moment(currentTo).isSame(previousFrom) || moment(currentFrom).isSame(previousTo))
          if(isInBetween){
            return false;
          }
        }
      }
    }
    //commented for future use
    // else if(insideDateRange){
    //   const {fromDateFieldKey, toDateFieldKey} = insideDateRange;
    //   const currentFrom = moment(newEntry[fromDateFieldKey], dateFormat);
    //   const currentTo = moment(newEntry[toDateFieldKey], dateFormat);
    //   if(toDateFieldKey && fromDateFieldKey && currentFrom && currentTo){
    //     for(let i = 0; i < gridData.length; i++){
    //       if(i == id - 1) continue;
    //       const data = gridData[i] || {};
    //       const previousFrom = data[fromDateFieldKey] && moment(data[fromDateFieldKey], dateFormat);
    //       const previousTo = moment(data[toDateFieldKey], dateFormat);
    //       const isInBetween = moment(previousFrom).isBetween(currentFrom, currentTo) || moment(previousTo).isBetween(currentFrom, currentTo) || moment(currentFrom).isBetween(previousFrom, previousTo) || moment(currentTo).isBetween(previousFrom, previousTo)
    //       if(!isInBetween){
    //         return false;
    //       }
    //     }
    //   }
    // }
  }
  return true;
}